/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	var _modulesIndex = __webpack_require__(64);
	
	var _modulesIndex2 = _interopRequireDefault(_modulesIndex);
	
	var _servicesIndex = __webpack_require__(93);
	
	var _servicesIndex2 = _interopRequireDefault(_servicesIndex);
	
	var _filtersIndex = __webpack_require__(40);
	
	var _filtersIndex2 = _interopRequireDefault(_filtersIndex);
	
	angular.module("ng.admin", ["ui.router", "sn.components", _servicesIndex2["default"], _filtersIndex2["default"], _modulesIndex2["default"]]).config(["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
		$urlRouterProvider.otherwise("/dashboard");
	
		$stateProvider.state("Dashboard", {
			url: "/dashboard",
			template: "<sn-dashboard></sn-dashboard>"
		}).state("Messages", {
			url: "/messages",
			template: "<sn-message-list></sn-message-list>"
		}).state("Platform", {
			url: "/platform",
			template: "<h1>Platform</h1>"
		}).state("Entity", {
			url: "/entity",
			template: "<sn-entity-manage></sn-entity-manage>"
		}).state("Employees", {
			url: "/employee-list",
			template: "<sn-employee-list></sn-employee-list>"
		}).state("UI Elements", {
			url: "/ui-elements",
			template: "<h1>UI Elements</h1>"
		}).state("Demos", {
			url: "/demos",
			template: "<h1>Demos</h1>"
		}).state("Euclid", {
			url: "/euclid",
			template: "<sn-euclid></sn-euclid>"
		}).state("Choice", {
			url: "/choice",
			template: "<sn-choice></sn-choice>"
		}).state("Sample Pages", {
			url: "/sample-pages",
			template: "<h1>Sample Pages</h1>"
		});
	}]);
	
	/*
	.state('state2.list', {
		url: "/list",
		templateUrl: "partials/state2.list.html",
		controller: function ($scope) {
			$scope.things = ["A", "Set", "Of", "Things"];
		}
	})*/

/***/ },
/* 1 */
/***/ function(module, exports) {

	"use strict";
	
	exports["default"] = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	exports.__esModule = true;

/***/ },
/* 2 */
/***/ function(module, exports) {

	"use strict";
	
	exports["default"] = function (obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	};
	
	exports.__esModule = true;

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _Object$defineProperty = __webpack_require__(102)["default"];
	
	exports["default"] = (function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	
	      _Object$defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	})();
	
	exports.__esModule = true;

/***/ },
/* 4 */
/***/ function(module, exports) {

	var $Object = Object;
	module.exports = {
	  create:     $Object.create,
	  getProto:   $Object.getPrototypeOf,
	  isEnum:     {}.propertyIsEnumerable,
	  getDesc:    $Object.getOwnPropertyDescriptor,
	  setDesc:    $Object.defineProperty,
	  setDescs:   $Object.defineProperties,
	  getKeys:    $Object.keys,
	  getNames:   $Object.getOwnPropertyNames,
	  getSymbols: $Object.getOwnPropertySymbols,
	  each:       [].forEach
	};

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	var store  = __webpack_require__(123)('wks')
	  , Symbol = __webpack_require__(9).Symbol;
	module.exports = function(name){
	  return store[name] || (store[name] =
	    Symbol && Symbol[name] || (Symbol || __webpack_require__(35))('Symbol.' + name));
	};

/***/ },
/* 6 */
/***/ function(module, exports) {

	var core = module.exports = {};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(9)
	  , core      = __webpack_require__(6)
	  , PROTOTYPE = 'prototype';
	function ctx(fn, that){
	  return function(){
	    return fn.apply(that, arguments);
	  };
	}
	// type bitmap
	$def.F = 1;  // forced
	$def.G = 2;  // global
	$def.S = 4;  // static
	$def.P = 8;  // proto
	$def.B = 16; // bind
	$def.W = 32; // wrap
	function $def(type, name, source){
	  var key, own, out, exp
	    , isGlobal = type & $def.G
	    , isProto  = type & $def.P
	    , target   = isGlobal ? global : type & $def.S
	        ? global[name] : (global[name] || {})[PROTOTYPE]
	    , exports  = isGlobal ? core : core[name] || (core[name] = {});
	  if(isGlobal)source = name;
	  for(key in source){
	    // contains in native
	    own = !(type & $def.F) && target && key in target;
	    if(own && key in exports)continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    if(isGlobal && typeof target[key] != 'function')exp = source[key];
	    // bind timers to global for call from export context
	    else if(type & $def.B && own)exp = ctx(out, global);
	    // wrap global constructors for prevent change them in library
	    else if(type & $def.W && target[key] == out)!function(C){
	      exp = function(param){
	        return this instanceof C ? new C(param) : C(param);
	      };
	      exp[PROTOTYPE] = C[PROTOTYPE];
	    }(out);
	    else exp = isProto && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export
	    exports[key] = exp;
	    if(isProto)(exports[PROTOTYPE] || (exports[PROTOTYPE] = {}))[key] = out;
	  }
	}
	module.exports = $def;

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	var $          = __webpack_require__(4)
	  , createDesc = __webpack_require__(30);
	module.exports = __webpack_require__(13) ? function(object, key, value){
	  return $.setDesc(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ },
/* 9 */
/***/ function(module, exports) {

	var global = typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	module.exports = global;
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ },
/* 10 */
/***/ function(module, exports) {

	module.exports = {};

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	// Optional / simple context binding
	var aFunction = __webpack_require__(113);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(~length && that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  } return function(/* ...args */){
	      return fn.apply(that, arguments);
	    };
	};

/***/ },
/* 12 */
/***/ function(module, exports) {

	// http://jsperf.com/core-js-isobject
	module.exports = function(it){
	  return it !== null && (typeof it == 'object' || typeof it == 'function');
	};

/***/ },
/* 13 */
/***/ function(module, exports) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !!function(){
	  try {
	    return Object.defineProperty({}, 'a', {get: function(){ return 2; }}).a == 2;
	  } catch(e){ /* empty */ }
	}();

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	var ES5Object = __webpack_require__(117)
	  , defined   = __webpack_require__(16);
	module.exports = function(it, realString){
	  return (realString ? Object : ES5Object)(defined(it));
	};

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(12);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ },
/* 16 */
/***/ function(module, exports) {

	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	var ctx         = __webpack_require__(11)
	  , call        = __webpack_require__(27)
	  , isArrayIter = __webpack_require__(25)
	  , anObject    = __webpack_require__(15)
	  , toLength    = __webpack_require__(34)
	  , getIterFn   = __webpack_require__(36);
	module.exports = function(iterable, entries, fn, that){
	  var iterFn = getIterFn(iterable)
	    , f      = ctx(fn, that, entries ? 2 : 1)
	    , index  = 0
	    , length, step, iterator;
	  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
	    entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
	    call(iterator, f, step.value, entries);
	  }
	};

/***/ },
/* 18 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY         = __webpack_require__(121)
	  , $def            = __webpack_require__(7)
	  , $redef          = __webpack_require__(31)
	  , hide            = __webpack_require__(8)
	  , has             = __webpack_require__(18)
	  , SYMBOL_ITERATOR = __webpack_require__(5)('iterator')
	  , Iterators       = __webpack_require__(10)
	  , FF_ITERATOR     = '@@iterator'
	  , KEYS            = 'keys'
	  , VALUES          = 'values';
	function returnThis(){ return this; }
	module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCE){
	  __webpack_require__(119)(Constructor, NAME, next);
	  function createMethod(kind){
	    switch(kind){
	      case KEYS: return function keys(){ return new Constructor(this, kind); };
	      case VALUES: return function values(){ return new Constructor(this, kind); };
	    } return function entries(){ return new Constructor(this, kind); };
	  }
	  var TAG      = NAME + ' Iterator'
	    , proto    = Base.prototype
	    , _native  = proto[SYMBOL_ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
	    , _default = _native || createMethod(DEFAULT)
	    , methods, key;
	  // Fix native
	  if(_native){
	    var IteratorPrototype = __webpack_require__(4).getProto(_default.call(new Base));
	    // Set @@toStringTag to native iterators
	    __webpack_require__(20)(IteratorPrototype, TAG, true);
	    // FF fix
	    if(!LIBRARY && has(proto, FF_ITERATOR))hide(IteratorPrototype, SYMBOL_ITERATOR, returnThis);
	  }
	  // Define iterator
	  if(!LIBRARY || FORCE)hide(proto, SYMBOL_ITERATOR, _default);
	  // Plug for library
	  Iterators[NAME] = _default;
	  Iterators[TAG]  = returnThis;
	  if(DEFAULT){
	    methods = {
	      keys:    IS_SET            ? _default : createMethod(KEYS),
	      values:  DEFAULT == VALUES ? _default : createMethod(VALUES),
	      entries: DEFAULT != VALUES ? _default : createMethod('entries')
	    };
	    if(FORCE)for(key in methods){
	      if(!(key in proto))$redef(proto, key, methods[key]);
	    } else $def($def.P + $def.F * __webpack_require__(26), NAME, methods);
	  }
	};

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	var has  = __webpack_require__(18)
	  , hide = __webpack_require__(8)
	  , TAG  = __webpack_require__(5)('toStringTag');
	
	module.exports = function(it, tag, stat){
	  if(it && !has(it = stat ? it : it.prototype, TAG))hide(it, TAG, tag);
	};

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = __webpack_require__(3)["default"];
	
	var _classCallCheck = __webpack_require__(1)["default"];
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var MessageListController = (function () {
		function MessageListController(PortalService) {
			_classCallCheck(this, MessageListController);
	
			this.messageCols = [{ label: "Title", key: "title" }, { label: "Content", key: "content" }, { label: "Date", key: "date" }];
			this.messageList = [];
	
			this.PortalService = PortalService;
		}
	
		_createClass(MessageListController, [{
			key: "init",
			value: function init() {
				var _this = this;
	
				this.PortalService.getMessageList().then(function (result) {
					return _this.messageList = result;
				});
			}
		}]);
	
		return MessageListController;
	})();
	
	exports["default"] = MessageListController;
	
	MessageListController.$inject = ["PortalService"];
	module.exports = exports["default"];

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(109), __esModule: true };

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(24)
	  , TAG = __webpack_require__(5)('toStringTag')
	  // ES3 wrong here
	  , ARG = cof(function(){ return arguments; }()) == 'Arguments';
	
	module.exports = function(it){
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = (O = Object(it))[TAG]) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};

/***/ },
/* 24 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function(it){
	  return toString.call(it).slice(8, -1);
	};

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	var Iterators = __webpack_require__(10)
	  , ITERATOR  = __webpack_require__(5)('iterator');
	module.exports = function(it){
	  return ('Array' in Iterators ? Iterators.Array : Array.prototype[ITERATOR]) === it;
	};

/***/ },
/* 26 */
/***/ function(module, exports) {

	// Safari has buggy iterators w/o `next`
	module.exports = 'keys' in [] && !('next' in [].keys());

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(15);
	function close(iterator){
	  var ret = iterator['return'];
	  if(ret !== undefined)anObject(ret.call(iterator));
	}
	module.exports = function(iterator, fn, value, entries){
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  } catch(e){
	    close(iterator);
	    throw e;
	  }
	};

/***/ },
/* 28 */
/***/ function(module, exports) {

	module.exports = function(done, value){
	  return {value: value, done: !!done};
	};

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	var $redef = __webpack_require__(31);
	module.exports = function(target, src){
	  for(var key in src)$redef(target, key, src[key]);
	  return target;
	};

/***/ },
/* 30 */
/***/ function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(8);

/***/ },
/* 32 */
/***/ function(module, exports) {

	module.exports = function(it, Constructor, name){
	  if(!(it instanceof Constructor))throw TypeError(name + ": use the 'new' operator!");
	  return it;
	};

/***/ },
/* 33 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil  = Math.ceil
	  , floor = Math.floor;
	module.exports = function(it){
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(33)
	  , min       = Math.min;
	module.exports = function(it){
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

/***/ },
/* 35 */
/***/ function(module, exports) {

	var id = 0
	  , px = Math.random();
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(9)
	  , classof   = __webpack_require__(23)
	  , ITERATOR  = __webpack_require__(5)('iterator')
	  , Iterators = __webpack_require__(10);
	module.exports = __webpack_require__(6).getIteratorMethod = function(it){
	  var Symbol = global.Symbol;
	  if(it != undefined){
	    return it[Symbol && Symbol.iterator || '@@iterator']
	      || it[ITERATOR]
	      || Iterators[classof(it)];
	  }
	};

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	var $at  = __webpack_require__(125)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(19)(String, 'String', function(iterated){
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , index = this._i
	    , point;
	  if(index >= O.length)return {value: undefined, done: true};
	  point = $at(O, index);
	  this._i += point.length;
	  return {value: point, done: false};
	});

/***/ },
/* 38 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.fromNow = fromNow;
	
	function fromNow(date) {
		return moment(date).fromNow();
	}

/***/ },
/* 39 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.gender = gender;
	var genders = ["Female", "Male"];
	
	function gender(gender) {
		gender = gender - 0;
		return genders[gender];
	}

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _datetime = __webpack_require__(38);
	
	var _gender = __webpack_require__(39);
	
	exports["default"] = angular.module("filters", []).filter("fromNow", function () {
		return _datetime.fromNow;
	}).filter("gender", function () {
		return _gender.gender;
	}).name;
	module.exports = exports["default"];

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = __webpack_require__(3)["default"];
	
	var _classCallCheck = __webpack_require__(1)["default"];
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var ChatController = (function () {
		function ChatController(ChatService) {
			_classCallCheck(this, ChatController);
	
			this.ChatService = ChatService;
	
			this.chatList = [];
			this.newMessage = "";
		}
	
		_createClass(ChatController, [{
			key: "init",
			value: function init() {
				var _this = this;
	
				this.ChatService.getChatList().then(function (result) {
					return _this.chatList = result;
				});
			}
		}, {
			key: "sendMessage",
			value: function sendMessage() {
				this.ChatService.sendMessage(this.newMessage);
	
				this.newMessage = "";
			}
		}]);
	
		return ChatController;
	})();
	
	exports["default"] = ChatController;
	
	ChatController.$inject = ["ChatService"];
	module.exports = exports["default"];

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = __webpack_require__(3)["default"];
	
	var _classCallCheck = __webpack_require__(1)["default"];
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var DashboardController = (function () {
		function DashboardController() {
			_classCallCheck(this, DashboardController);
	
			this.aggregationItems = [];
		}
	
		_createClass(DashboardController, [{
			key: "init",
			value: function init() {
				this.aggregationItems = [{ theme: "primary", icon: "fa-comments", count: 26, content: "New Comments!", state: "Comments" }, { theme: "info", icon: "fa-tasks", count: 14, content: "New Messages!", state: "Messages" }, { theme: "success", icon: "fa-shopping-cart", count: 124, content: "New Orders!", state: "Orders" }, { theme: "warning", icon: "fa-support", count: 13, content: "Support Tickets!", state: "Tickets" }];
			}
		}]);
	
		return DashboardController;
	})();
	
	exports["default"] = DashboardController;
	module.exports = exports["default"];

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = __webpack_require__(3)["default"];
	
	var _classCallCheck = __webpack_require__(1)["default"];
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var NotificationController = (function () {
		function NotificationController(NotificationService) {
			_classCallCheck(this, NotificationController);
	
			this.NotificationService = NotificationService;
	
			this.notifications = [];
		}
	
		_createClass(NotificationController, [{
			key: "init",
			value: function init() {
				var _this = this;
	
				this.NotificationService.getNotifications().then(function (result) {
					return _this.notifications = result;
				});
			}
		}]);
	
		return NotificationController;
	})();
	
	exports["default"] = NotificationController;
	
	NotificationController.$inject = ["NotificationService"];
	module.exports = exports["default"];

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = __webpack_require__(3)["default"];
	
	var _classCallCheck = __webpack_require__(1)["default"];
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var TimelineController = (function () {
		function TimelineController(TimelineService) {
			_classCallCheck(this, TimelineController);
	
			this.TimelineService = TimelineService;
	
			this.timeline = [];
		}
	
		_createClass(TimelineController, [{
			key: "init",
			value: function init() {
				var _this = this;
	
				this.TimelineService.getTimeline().then(function (result) {
					return _this.timeline = result;
				});
			}
		}]);
	
		return TimelineController;
	})();
	
	exports["default"] = TimelineController;
	
	TimelineController.$inject = ["TimelineService"];
	module.exports = exports["default"];

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _classCallCheck = __webpack_require__(1)["default"];
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _templatesAggregationItemPanelHtml = __webpack_require__(140);
	
	var _templatesAggregationItemPanelHtml2 = _interopRequireDefault(_templatesAggregationItemPanelHtml);
	
	__webpack_require__(135);
	
	var AggregationItemPanelDirective = function AggregationItemPanelDirective() {
		_classCallCheck(this, AggregationItemPanelDirective);
	
		this.template = _templatesAggregationItemPanelHtml2["default"];
		this.restrict = "E";
		this.scope = {
			data: "="
		};
	};
	
	exports["default"] = AggregationItemPanelDirective;
	module.exports = exports["default"];

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _classCallCheck = __webpack_require__(1)["default"];
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _templatesAreaChartPanelHtml = __webpack_require__(141);
	
	var _templatesAreaChartPanelHtml2 = _interopRequireDefault(_templatesAreaChartPanelHtml);
	
	var AreaChartPanelDirective = function AreaChartPanelDirective() {
		_classCallCheck(this, AreaChartPanelDirective);
	
		this.template = _templatesAreaChartPanelHtml2["default"];
		this.restrict = "E";
	};
	
	exports["default"] = AreaChartPanelDirective;
	module.exports = exports["default"];

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _classCallCheck = __webpack_require__(1)["default"];
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _templatesBarChartPanelHtml = __webpack_require__(142);
	
	var _templatesBarChartPanelHtml2 = _interopRequireDefault(_templatesBarChartPanelHtml);
	
	var BarChartPanelDirective = function BarChartPanelDirective() {
		_classCallCheck(this, BarChartPanelDirective);
	
		this.template = _templatesBarChartPanelHtml2["default"];
		this.restrict = "E";
	};
	
	exports["default"] = BarChartPanelDirective;
	module.exports = exports["default"];

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _classCallCheck = __webpack_require__(1)["default"];
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _templatesChatPanelHtml = __webpack_require__(143);
	
	var _templatesChatPanelHtml2 = _interopRequireDefault(_templatesChatPanelHtml);
	
	var _controllersChat = __webpack_require__(41);
	
	var _controllersChat2 = _interopRequireDefault(_controllersChat);
	
	__webpack_require__(136);
	
	var ChatPanelDirective = function ChatPanelDirective() {
		_classCallCheck(this, ChatPanelDirective);
	
		this.template = _templatesChatPanelHtml2["default"];
		this.restrict = "E";
		this.controller = _controllersChat2["default"];
		this.controllerAs = "chatCtrl";
	};
	
	exports["default"] = ChatPanelDirective;
	module.exports = exports["default"];

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _classCallCheck = __webpack_require__(1)["default"];
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _templatesDashboardHtml = __webpack_require__(144);
	
	var _templatesDashboardHtml2 = _interopRequireDefault(_templatesDashboardHtml);
	
	var _controllersDashboard = __webpack_require__(42);
	
	var _controllersDashboard2 = _interopRequireDefault(_controllersDashboard);
	
	//import "../css/dashboard.css";
	
	var DashboardDirective = function DashboardDirective() {
		_classCallCheck(this, DashboardDirective);
	
		this.template = _templatesDashboardHtml2["default"];
		this.restrict = "E";
		this.controller = _controllersDashboard2["default"];
		this.controllerAs = "dashboardCtrl";
	};
	
	exports["default"] = DashboardDirective;
	module.exports = exports["default"];

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _classCallCheck = __webpack_require__(1)["default"];
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _templatesDonutChartPanelHtml = __webpack_require__(145);
	
	var _templatesDonutChartPanelHtml2 = _interopRequireDefault(_templatesDonutChartPanelHtml);
	
	var DonutChartPanelDirective = function DonutChartPanelDirective() {
		_classCallCheck(this, DonutChartPanelDirective);
	
		this.template = _templatesDonutChartPanelHtml2["default"];
		this.restrict = "E";
	};
	
	exports["default"] = DonutChartPanelDirective;
	module.exports = exports["default"];

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _classCallCheck = __webpack_require__(1)["default"];
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _templatesNotificationPanelHtml = __webpack_require__(146);
	
	var _templatesNotificationPanelHtml2 = _interopRequireDefault(_templatesNotificationPanelHtml);
	
	var _controllersNotification = __webpack_require__(43);
	
	var _controllersNotification2 = _interopRequireDefault(_controllersNotification);
	
	var NotificationPanelDirective = function NotificationPanelDirective() {
		_classCallCheck(this, NotificationPanelDirective);
	
		this.template = _templatesNotificationPanelHtml2["default"];
		this.restrict = "E";
		this.controller = _controllersNotification2["default"];
		this.controllerAs = "notificationCtrl";
	};
	
	exports["default"] = NotificationPanelDirective;
	module.exports = exports["default"];

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _classCallCheck = __webpack_require__(1)["default"];
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _templatesTimelinePanelHtml = __webpack_require__(147);
	
	var _templatesTimelinePanelHtml2 = _interopRequireDefault(_templatesTimelinePanelHtml);
	
	var _controllersTimeline = __webpack_require__(44);
	
	var _controllersTimeline2 = _interopRequireDefault(_controllersTimeline);
	
	__webpack_require__(137);
	
	var TimelinePanelDirective = function TimelinePanelDirective() {
		_classCallCheck(this, TimelinePanelDirective);
	
		this.template = _templatesTimelinePanelHtml2["default"];
		this.restrict = "E";
		this.controller = _controllersTimeline2["default"];
		this.controllerAs = "timelineCtrl";
	};
	
	exports["default"] = TimelinePanelDirective;
	module.exports = exports["default"];

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _directivesDashboard = __webpack_require__(49);
	
	var _directivesDashboard2 = _interopRequireDefault(_directivesDashboard);
	
	var _directivesAggregationItemPanel = __webpack_require__(45);
	
	var _directivesAggregationItemPanel2 = _interopRequireDefault(_directivesAggregationItemPanel);
	
	var _directivesChatPanel = __webpack_require__(48);
	
	var _directivesChatPanel2 = _interopRequireDefault(_directivesChatPanel);
	
	var _directivesTimelinePanel = __webpack_require__(52);
	
	var _directivesTimelinePanel2 = _interopRequireDefault(_directivesTimelinePanel);
	
	var _directivesAreaChartPanel = __webpack_require__(46);
	
	var _directivesAreaChartPanel2 = _interopRequireDefault(_directivesAreaChartPanel);
	
	var _directivesBarChartPanel = __webpack_require__(47);
	
	var _directivesBarChartPanel2 = _interopRequireDefault(_directivesBarChartPanel);
	
	var _directivesDonutChartPanel = __webpack_require__(50);
	
	var _directivesDonutChartPanel2 = _interopRequireDefault(_directivesDonutChartPanel);
	
	var _directivesNotificationPanel = __webpack_require__(51);
	
	var _directivesNotificationPanel2 = _interopRequireDefault(_directivesNotificationPanel);
	
	exports["default"] = angular.module("modules.dashboard", []).directive("snDashboard", function () {
		return new _directivesDashboard2["default"]();
	}).directive("snAggregationItemPanel", function () {
		return new _directivesAggregationItemPanel2["default"]();
	}).directive("snChatPanel", function () {
		return new _directivesChatPanel2["default"]();
	}).directive("snTimelinePanel", function () {
		return new _directivesTimelinePanel2["default"]();
	}).directive("snAreaChartPanel", function () {
		return new _directivesAreaChartPanel2["default"]();
	}).directive("snBarChartPanel", function () {
		return new _directivesBarChartPanel2["default"]();
	}).directive("snDonutChartPanel", function () {
		return new _directivesDonutChartPanel2["default"]();
	}).directive("snNotificationPanel", function () {
		return new _directivesNotificationPanel2["default"]();
	}).name;
	module.exports = exports["default"];

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = __webpack_require__(3)["default"];
	
	var _classCallCheck = __webpack_require__(1)["default"];
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var ChoiceController = (function () {
		function ChoiceController(FlowService) {
			_classCallCheck(this, ChoiceController);
	
			this.FlowService = FlowService;
		}
	
		_createClass(ChoiceController, [{
			key: "init",
			value: function init() {
				var _this = this;
	
				var data = {
					name: "Choice",
					activities: [{ id: "a00", type: "start", action: "this.step=0" }, { id: "a01", type: "normal", action: "var temp=this.a%this.b; this.a=this.b; this.b=temp;" }, { id: "a02", type: "finish", action: "this.result=this.b;" }],
					transitions: [{ id: "b00", from: "a00", to: "a01", condition: "return true" }, { id: "b01", from: "a01", to: "a01", condition: "return this.a%this.b!=0" }, { id: "b02", from: "a01", to: "a02", condition: "return this.a%this.b==0" }]
				};
	
				this.FlowService.getFlow(data).then(function (result) {
					_this.flow = result;
					_this.flow.executeStep();
				});
			}
		}]);
	
		return ChoiceController;
	})();
	
	exports["default"] = ChoiceController;
	
	ChoiceController.$inject = ["FlowService"];
	module.exports = exports["default"];

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = __webpack_require__(3)["default"];
	
	var _classCallCheck = __webpack_require__(1)["default"];
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var EuclidController = (function () {
		function EuclidController(FlowService) {
			_classCallCheck(this, EuclidController);
	
			this.FlowService = FlowService;
		}
	
		_createClass(EuclidController, [{
			key: "init",
			value: function init() {
				var _this = this;
	
				var data = {
					name: "Euclid",
					activities: [{ id: "a00", type: "start", action: "this.a=72; this.b=45;" }, { id: "a01", type: "normal", action: "var temp=this.a%this.b; this.a=this.b; this.b=temp;" }, { id: "a02", type: "finish", action: "this.result=this.b;" }],
					transitions: [{ id: "b00", from: "a00", to: "a01", condition: "return true" }, { id: "b01", from: "a01", to: "a01", condition: "return this.a%this.b!=0" }, { id: "b02", from: "a01", to: "a02", condition: "return this.a%this.b==0" }]
				};
	
				this.FlowService.getFlow(data).then(function (result) {
					_this.flow = result;
					_this.flow.executeStep();
				});
			}
		}, {
			key: "next",
			value: function next() {
				this.flow.executeStep();
			}
		}]);
	
		return EuclidController;
	})();
	
	exports["default"] = EuclidController;
	
	EuclidController.$inject = ["FlowService"];
	module.exports = exports["default"];

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _classCallCheck = __webpack_require__(1)["default"];
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _templatesChoiceHtml = __webpack_require__(148);
	
	var _templatesChoiceHtml2 = _interopRequireDefault(_templatesChoiceHtml);
	
	var _controllersChoice = __webpack_require__(54);
	
	var _controllersChoice2 = _interopRequireDefault(_controllersChoice);
	
	var ChoiceDirective = function ChoiceDirective() {
		_classCallCheck(this, ChoiceDirective);
	
		this.template = _templatesChoiceHtml2["default"];
		this.restrict = "E";
		this.replace = true;
		this.controller = _controllersChoice2["default"];
		this.controllerAs = "choiceCtrl";
	};
	
	exports["default"] = ChoiceDirective;
	module.exports = exports["default"];

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _classCallCheck = __webpack_require__(1)["default"];
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _templatesEuclidHtml = __webpack_require__(149);
	
	var _templatesEuclidHtml2 = _interopRequireDefault(_templatesEuclidHtml);
	
	var _controllersEuclid = __webpack_require__(55);
	
	var _controllersEuclid2 = _interopRequireDefault(_controllersEuclid);
	
	var EuclidDirective = function EuclidDirective() {
		_classCallCheck(this, EuclidDirective);
	
		this.template = _templatesEuclidHtml2["default"];
		this.restrict = "E";
		this.replace = true;
		this.controller = _controllersEuclid2["default"];
		this.controllerAs = "euclidCtrl";
	};
	
	exports["default"] = EuclidDirective;
	module.exports = exports["default"];

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _directivesEuclid = __webpack_require__(57);
	
	var _directivesEuclid2 = _interopRequireDefault(_directivesEuclid);
	
	var _directivesChoice = __webpack_require__(56);
	
	var _directivesChoice2 = _interopRequireDefault(_directivesChoice);
	
	exports["default"] = angular.module("modules.demo.flow", []).directive("snEuclid", function () {
		return new _directivesEuclid2["default"]();
	}).directive("snChoice", function () {
		return new _directivesChoice2["default"]();
	}).name;
	module.exports = exports["default"];

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _flowIndex = __webpack_require__(58);
	
	var _flowIndex2 = _interopRequireDefault(_flowIndex);
	
	exports["default"] = angular.module("modules.demo", [_flowIndex2["default"]]).name;
	module.exports = exports["default"];

/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = __webpack_require__(3)["default"];
	
	var _classCallCheck = __webpack_require__(1)["default"];
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _templatesNewEmployeeDialogHtml = __webpack_require__(151);
	
	var _templatesNewEmployeeDialogHtml2 = _interopRequireDefault(_templatesNewEmployeeDialogHtml);
	
	var EmployeeListController = (function () {
		function EmployeeListController(EmployeeService, DialogService, AlertService) {
			_classCallCheck(this, EmployeeListController);
	
			this.EmployeeService = EmployeeService;
			this.DialogService = DialogService;
			this.AlertService = AlertService;
	
			this.total = 0;
			this.employeeList = [];
			this.selectedEmployee = null;
		}
	
		_createClass(EmployeeListController, [{
			key: "init",
			value: function init() {
				this.getEmployeeList(0);
			}
		}, {
			key: "getEmployeeList",
			value: function getEmployeeList(index) {
				var _this = this;
	
				this.EmployeeService.getEmployeeList(index, 10).then(function (result) {
					_this.employeeList = result.employeeList;
					_this.total = result.total;
					_this.selectedEmployee = null;
				});
			}
		}, {
			key: "newEmployee",
			value: function newEmployee() {
				var _this2 = this;
	
				this.DialogService.modal(_templatesNewEmployeeDialogHtml2["default"], null, function (result) {
					return _this2.employeeList.push(result);
				});
			}
		}, {
			key: "deleteEmployee",
			value: function deleteEmployee() {
				var _this3 = this;
	
				this.AlertService.confirm({ title: "Delete Employee", content: "Are you sure?" }).then(function () {
					_this3.EmployeeService.deleteEmployee(_this3.selectedEmployee).then(function () {
						return _this3.employeeList = _this3.employeeList.filter(function (it) {
							return it != _this3.selectedEmployee;
						});
					});
				});
			}
		}]);
	
		return EmployeeListController;
	})();
	
	exports["default"] = EmployeeListController;
	
	EmployeeListController.$inject = ["EmployeeService", "DialogService", "AlertService"];
	module.exports = exports["default"];

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = __webpack_require__(3)["default"];
	
	var _classCallCheck = __webpack_require__(1)["default"];
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var NewEmployeeDialogController = (function () {
		function NewEmployeeDialogController(EmployeeService) {
			_classCallCheck(this, NewEmployeeDialogController);
	
			this.EmployeeService = EmployeeService;
		}
	
		_createClass(NewEmployeeDialogController, [{
			key: "ok",
			value: function ok() {
				var _this = this;
	
				this.EmployeeService.addEmployee({
					name: this.name,
					age: this.age,
					gender: this.gender
				}).then(function (result) {
					return _this.dialog.onOk(result);
				});
			}
		}]);
	
		return NewEmployeeDialogController;
	})();
	
	exports["default"] = NewEmployeeDialogController;
	
	NewEmployeeDialogController.$inject = ["EmployeeService"];
	module.exports = exports["default"];

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = __webpack_require__(3)["default"];
	
	var _classCallCheck = __webpack_require__(1)["default"];
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _templatesEmployeeListHtml = __webpack_require__(150);
	
	var _templatesEmployeeListHtml2 = _interopRequireDefault(_templatesEmployeeListHtml);
	
	var _controllersEmployeeList = __webpack_require__(60);
	
	var _controllersEmployeeList2 = _interopRequireDefault(_controllersEmployeeList);
	
	var EmployeeListDirective = (function () {
		function EmployeeListDirective() {
			_classCallCheck(this, EmployeeListDirective);
	
			this.template = _templatesEmployeeListHtml2["default"];
			this.restrict = "E";
			this.replace = true;
			this.controller = _controllersEmployeeList2["default"];
			this.controllerAs = "employeeListCtrl";
		}
	
		_createClass(EmployeeListDirective, [{
			key: "link",
			value: function link(scope, element, attrs) {
				scope.$watch("employeeListCtrl.currentPage", function (page) {
					if (page) {
						scope.employeeListCtrl.getEmployeeList(page.index);
					}
				});
			}
		}]);
	
		return EmployeeListDirective;
	})();
	
	exports["default"] = EmployeeListDirective;
	module.exports = exports["default"];

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _directivesEmployeeList = __webpack_require__(62);
	
	var _directivesEmployeeList2 = _interopRequireDefault(_directivesEmployeeList);
	
	var _controllersNewEmployeeDialog = __webpack_require__(61);
	
	var _controllersNewEmployeeDialog2 = _interopRequireDefault(_controllersNewEmployeeDialog);
	
	exports["default"] = angular.module("modules.employee", []).directive("snEmployeeList", function () {
		return new _directivesEmployeeList2["default"]();
	}).controller("NewEmployeeDialogController", _controllersNewEmployeeDialog2["default"]).name;
	module.exports = exports["default"];

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _portalIndex = __webpack_require__(85);
	
	var _portalIndex2 = _interopRequireDefault(_portalIndex);
	
	var _dashboardIndex = __webpack_require__(53);
	
	var _dashboardIndex2 = _interopRequireDefault(_dashboardIndex);
	
	var _platformIndex = __webpack_require__(75);
	
	var _platformIndex2 = _interopRequireDefault(_platformIndex);
	
	var _employeeIndex = __webpack_require__(63);
	
	var _employeeIndex2 = _interopRequireDefault(_employeeIndex);
	
	var _demoIndex = __webpack_require__(59);
	
	var _demoIndex2 = _interopRequireDefault(_demoIndex);
	
	exports["default"] = angular.module("modules", [_portalIndex2["default"], _dashboardIndex2["default"], _platformIndex2["default"], _employeeIndex2["default"], _demoIndex2["default"]]).name;
	module.exports = exports["default"];

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = __webpack_require__(3)["default"];
	
	var _classCallCheck = __webpack_require__(1)["default"];
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var EntityListController = (function () {
		function EntityListController(EntityService) {
			_classCallCheck(this, EntityListController);
	
			this.EntityService = EntityService;
		}
	
		_createClass(EntityListController, [{
			key: "init",
			value: function init() {
				var _this = this;
	
				this.EntityService.getEntityList().then(function (result) {
					return _this.entityList = result;
				});
			}
		}, {
			key: "selectEntity",
			value: function selectEntity(entity) {
				this.selectedEntity = entity;
			}
		}]);
	
		return EntityListController;
	})();
	
	exports["default"] = EntityListController;
	
	EntityListController.$inject = ["EntityService"];
	module.exports = exports["default"];

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = __webpack_require__(3)["default"];
	
	var _classCallCheck = __webpack_require__(1)["default"];
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var EntityManageController = (function () {
		function EntityManageController(EntityService) {
			_classCallCheck(this, EntityManageController);
	
			this.EntityService = EntityService;
		}
	
		_createClass(EntityManageController, [{
			key: "init",
			value: function init() {}
		}]);
	
		return EntityManageController;
	})();
	
	exports["default"] = EntityManageController;
	
	EntityManageController.$inject = ["EntityService"];
	module.exports = exports["default"];

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = __webpack_require__(3)["default"];
	
	var _classCallCheck = __webpack_require__(1)["default"];
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var EntityPropertyListController = (function () {
		function EntityPropertyListController(EntityService) {
			_classCallCheck(this, EntityPropertyListController);
	
			this.EntityService = EntityService;
		}
	
		_createClass(EntityPropertyListController, [{
			key: "init",
			value: function init() {}
		}, {
			key: "getPropertiesByEntity",
			value: function getPropertiesByEntity(entity) {
				var _this = this;
	
				this.EntityService.getPropertiesByEntity(entity).then(function (result) {
					return _this.propertyList = result;
				});
			}
		}]);
	
		return EntityPropertyListController;
	})();
	
	exports["default"] = EntityPropertyListController;
	
	EntityPropertyListController.$inject = ["EntityService"];
	module.exports = exports["default"];

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = __webpack_require__(3)["default"];
	
	var _classCallCheck = __webpack_require__(1)["default"];
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var EntityRuleListController = (function () {
		function EntityRuleListController(EntityService) {
			_classCallCheck(this, EntityRuleListController);
	
			this.EntityService = EntityService;
		}
	
		_createClass(EntityRuleListController, [{
			key: "init",
			value: function init() {}
		}, {
			key: "getRulesByEntity",
			value: function getRulesByEntity(entity) {
				var _this = this;
	
				this.EntityService.getRulesByEntity(entity).then(function (result) {
					return _this.ruleList = result;
				});
			}
		}]);
	
		return EntityRuleListController;
	})();
	
	exports["default"] = EntityRuleListController;
	
	EntityRuleListController.$inject = ["EntityService"];
	module.exports = exports["default"];

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = __webpack_require__(3)["default"];
	
	var _classCallCheck = __webpack_require__(1)["default"];
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var FlowController = (function () {
		function FlowController(FlowService) {
			_classCallCheck(this, FlowController);
	
			this.FlowService = FlowService;
		}
	
		_createClass(FlowController, [{
			key: "init",
			value: function init() {
				var _this = this;
	
				this.FlowService.getFlow().then(function (result) {
					return _this.flow = result;
				});
			}
		}, {
			key: "start",
			value: function start() {
				this.flow.execute();
			}
		}, {
			key: "step",
			value: function step() {
				this.flow.executeStep();
			}
		}]);
	
		return FlowController;
	})();
	
	exports["default"] = FlowController;
	
	FlowController.$inject = ["FlowService"];
	module.exports = exports["default"];

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _classCallCheck = __webpack_require__(1)["default"];
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _templatesEntityEntityListHtml = __webpack_require__(152);
	
	var _templatesEntityEntityListHtml2 = _interopRequireDefault(_templatesEntityEntityListHtml);
	
	var _controllersEntityEntityList = __webpack_require__(65);
	
	var _controllersEntityEntityList2 = _interopRequireDefault(_controllersEntityEntityList);
	
	var EntityListDirective = function EntityListDirective() {
		_classCallCheck(this, EntityListDirective);
	
		this.template = _templatesEntityEntityListHtml2["default"];
		this.restrict = "E";
		this.replace = true;
		this.controller = _controllersEntityEntityList2["default"];
		this.controllerAs = "entityListCtrl";
	
		this.scope = {
			selectedEntity: "="
		};
		this.bindToController = true;
	};
	
	exports["default"] = EntityListDirective;
	module.exports = exports["default"];

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _classCallCheck = __webpack_require__(1)["default"];
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _templatesEntityEntityManageHtml = __webpack_require__(153);
	
	var _templatesEntityEntityManageHtml2 = _interopRequireDefault(_templatesEntityEntityManageHtml);
	
	var _controllersEntityEntityManage = __webpack_require__(66);
	
	var _controllersEntityEntityManage2 = _interopRequireDefault(_controllersEntityEntityManage);
	
	var EntityManageDirective = function EntityManageDirective() {
		_classCallCheck(this, EntityManageDirective);
	
		this.template = _templatesEntityEntityManageHtml2["default"];
		this.restrict = "E";
		this.replace = true;
	
		this.controller = _controllersEntityEntityManage2["default"];
		this.controllerAs = "entityManageCtrl";
	};
	
	exports["default"] = EntityManageDirective;
	module.exports = exports["default"];

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = __webpack_require__(3)["default"];
	
	var _classCallCheck = __webpack_require__(1)["default"];
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _templatesEntityEntityPropertyListHtml = __webpack_require__(154);
	
	var _templatesEntityEntityPropertyListHtml2 = _interopRequireDefault(_templatesEntityEntityPropertyListHtml);
	
	var _controllersEntityEntityPropertyList = __webpack_require__(67);
	
	var _controllersEntityEntityPropertyList2 = _interopRequireDefault(_controllersEntityEntityPropertyList);
	
	var EntityPropertyListDirective = (function () {
		function EntityPropertyListDirective() {
			_classCallCheck(this, EntityPropertyListDirective);
	
			this.template = _templatesEntityEntityPropertyListHtml2["default"];
			this.restrict = "E";
			this.replace = true;
	
			this.controller = _controllersEntityEntityPropertyList2["default"];
			this.controllerAs = "entityPropertyListCtrl";
	
			this.scope = {
				selectedEntity: "="
			};
			this.bindToController = true;
		}
	
		_createClass(EntityPropertyListDirective, [{
			key: "link",
			value: function link(scope, element, attrs) {
				scope.$watch("entityPropertyListCtrl.selectedEntity", function (entity) {
					if (entity) {
						scope.entityPropertyListCtrl.getPropertiesByEntity(entity);
					}
				});
			}
		}]);
	
		return EntityPropertyListDirective;
	})();
	
	exports["default"] = EntityPropertyListDirective;
	module.exports = exports["default"];

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = __webpack_require__(3)["default"];
	
	var _classCallCheck = __webpack_require__(1)["default"];
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _templatesEntityEntityRuleListHtml = __webpack_require__(155);
	
	var _templatesEntityEntityRuleListHtml2 = _interopRequireDefault(_templatesEntityEntityRuleListHtml);
	
	var _controllersEntityEntityRuleList = __webpack_require__(68);
	
	var _controllersEntityEntityRuleList2 = _interopRequireDefault(_controllersEntityEntityRuleList);
	
	var EntityPropertyListDirective = (function () {
		function EntityPropertyListDirective() {
			_classCallCheck(this, EntityPropertyListDirective);
	
			this.template = _templatesEntityEntityRuleListHtml2["default"];
			this.restrict = "E";
			this.replace = true;
	
			this.controller = _controllersEntityEntityRuleList2["default"];
			this.controllerAs = "entityRuleListCtrl";
	
			this.scope = {
				selectedEntity: "="
			};
			this.bindToController = true;
		}
	
		_createClass(EntityPropertyListDirective, [{
			key: "link",
			value: function link(scope, element, attrs) {
				scope.$watch("entityRuleListCtrl.selectedEntity", function (entity) {
					if (entity) {
						scope.entityRuleListCtrl.getRulesByEntity(entity);
					}
				});
			}
		}]);
	
		return EntityPropertyListDirective;
	})();
	
	exports["default"] = EntityPropertyListDirective;
	module.exports = exports["default"];

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _classCallCheck = __webpack_require__(1)["default"];
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _templatesFlowFlowHtml = __webpack_require__(156);
	
	var _templatesFlowFlowHtml2 = _interopRequireDefault(_templatesFlowFlowHtml);
	
	var _controllersFlowFlow = __webpack_require__(69);
	
	var _controllersFlowFlow2 = _interopRequireDefault(_controllersFlowFlow);
	
	var EntityListDirective = function EntityListDirective() {
		_classCallCheck(this, EntityListDirective);
	
		this.template = _templatesFlowFlowHtml2["default"];
		this.restrict = "E";
		this.replace = true;
		this.controller = _controllersFlowFlow2["default"];
		this.controllerAs = "flowCtrl";
	};
	
	exports["default"] = EntityListDirective;
	module.exports = exports["default"];

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _directivesEntityEntityManage = __webpack_require__(71);
	
	var _directivesEntityEntityManage2 = _interopRequireDefault(_directivesEntityEntityManage);
	
	var _directivesEntityEntityList = __webpack_require__(70);
	
	var _directivesEntityEntityList2 = _interopRequireDefault(_directivesEntityEntityList);
	
	var _directivesEntityEntityPropertyList = __webpack_require__(72);
	
	var _directivesEntityEntityPropertyList2 = _interopRequireDefault(_directivesEntityEntityPropertyList);
	
	var _directivesEntityEntityRuleList = __webpack_require__(73);
	
	var _directivesEntityEntityRuleList2 = _interopRequireDefault(_directivesEntityEntityRuleList);
	
	var _directivesFlowFlow = __webpack_require__(74);
	
	var _directivesFlowFlow2 = _interopRequireDefault(_directivesFlowFlow);
	
	exports["default"] = angular.module("modules.platform", []).directive("snEntityManage", function () {
		return new _directivesEntityEntityManage2["default"]();
	}).directive("snEntityList", function () {
		return new _directivesEntityEntityList2["default"]();
	}).directive("snEntityPropertyList", function () {
		return new _directivesEntityEntityPropertyList2["default"]();
	}).directive("snEntityRuleList", function () {
		return new _directivesEntityEntityRuleList2["default"]();
	}).directive("snFlow", function () {
		return new _directivesFlowFlow2["default"]();
	}).name;
	module.exports = exports["default"];

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = __webpack_require__(3)["default"];
	
	var _classCallCheck = __webpack_require__(1)["default"];
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var AlertListController = (function () {
		function AlertListController(PortalService) {
			_classCallCheck(this, AlertListController);
	
			this.alertList = [];
	
			this.PortalService = PortalService;
	
			this.alertClasses = ["message", "twitter", "envelope", "tasks", "upload"];
		}
	
		_createClass(AlertListController, [{
			key: "init",
			value: function init() {
				var _this = this;
	
				this.PortalService.getAlertList().then(function (result) {
					return _this.alertList = result;
				});
			}
		}, {
			key: "alertClass",
			value: function alertClass(type) {
				return "fa-" + type;
			}
		}]);
	
		return AlertListController;
	})();
	
	exports["default"] = AlertListController;
	
	AlertListController.$inject = ["PortalService"];
	module.exports = exports["default"];

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = __webpack_require__(3)["default"];
	
	var _classCallCheck = __webpack_require__(1)["default"];
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var SideNavController = (function () {
		function SideNavController(PortalService) {
			_classCallCheck(this, SideNavController);
	
			this.menuList = [];
			this.menuTree = [];
			this.menuMap = {};
	
			this.PortalService = PortalService;
		}
	
		_createClass(SideNavController, [{
			key: "init",
			value: function init() {
				var _this = this;
	
				this.PortalService.getMenuList().then(function (menus) {
					menus.forEach(function (menuItem) {
						_this.menuMap[menuItem.code] = menuItem;
	
						if (!menuItem.parent) {
							_this.menuTree.push(menuItem);
						} else {
							var _parent = _this.menuMap[menuItem.parent];
							if (!_parent.children) {
								_parent.children = [];
							}
							_parent.children.push(menuItem);
							menuItem.parent = _parent;
						}
					});
	
					_this.menuList = menus;
				});
			}
		}, {
			key: "menuClick",
			value: function menuClick(menu, evt) {
				this.menuList.forEach(function (item) {
					if (item == menu) {
						menu.$expanded = !menu.$expanded;
					} else {
						if (item != menu.parent) {
							delete item.$expanded;
						}
					}
				});
	
				evt.stopPropagation();
			}
		}]);
	
		return SideNavController;
	})();
	
	exports["default"] = SideNavController;
	
	SideNavController.$inject = ["PortalService"];
	module.exports = exports["default"];

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = __webpack_require__(3)["default"];
	
	var _classCallCheck = __webpack_require__(1)["default"];
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var TaskListController = (function () {
		function TaskListController(PortalService) {
			_classCallCheck(this, TaskListController);
	
			this.taskList = [];
	
			this.PortalService = PortalService;
	
			this.taskClasses = ["primary", "success", "warning", "danger"];
		}
	
		_createClass(TaskListController, [{
			key: "init",
			value: function init() {
				var _this = this;
	
				this.PortalService.getTaskList().then(function (result) {
					return _this.taskList = result;
				});
			}
		}, {
			key: "taskClass",
			value: function taskClass(index) {
				return "progress-bar-" + this.taskClasses[index % this.taskClasses.length];
			}
		}]);
	
		return TaskListController;
	})();
	
	exports["default"] = TaskListController;
	
	TaskListController.$inject = ["PortalService"];
	module.exports = exports["default"];

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _classCallCheck = __webpack_require__(1)["default"];
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _templatesAlertDropdownHtml = __webpack_require__(157);
	
	var _templatesAlertDropdownHtml2 = _interopRequireDefault(_templatesAlertDropdownHtml);
	
	var _controllersAlertList = __webpack_require__(76);
	
	var _controllersAlertList2 = _interopRequireDefault(_controllersAlertList);
	
	var AlertDropdownDirective = function AlertDropdownDirective() {
		_classCallCheck(this, AlertDropdownDirective);
	
		this.template = _templatesAlertDropdownHtml2["default"];
		this.restrict = "E";
		this.replace = true;
		this.controller = _controllersAlertList2["default"];
		this.controllerAs = "alertListCtrl";
	};
	
	exports["default"] = AlertDropdownDirective;
	module.exports = exports["default"];

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _classCallCheck = __webpack_require__(1)["default"];
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _templatesMessageDropdownHtml = __webpack_require__(158);
	
	var _templatesMessageDropdownHtml2 = _interopRequireDefault(_templatesMessageDropdownHtml);
	
	var _controllersMessageList = __webpack_require__(21);
	
	var _controllersMessageList2 = _interopRequireDefault(_controllersMessageList);
	
	var MessageDropdowntDirective = function MessageDropdowntDirective() {
		_classCallCheck(this, MessageDropdowntDirective);
	
		this.template = _templatesMessageDropdownHtml2["default"];
		this.restrict = "E";
		this.replace = true;
		this.controller = _controllersMessageList2["default"];
		this.controllerAs = "messageListCtrl";
	};
	
	exports["default"] = MessageDropdowntDirective;
	module.exports = exports["default"];

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _classCallCheck = __webpack_require__(1)["default"];
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _templatesMessageListHtml = __webpack_require__(159);
	
	var _templatesMessageListHtml2 = _interopRequireDefault(_templatesMessageListHtml);
	
	var _controllersMessageList = __webpack_require__(21);
	
	var _controllersMessageList2 = _interopRequireDefault(_controllersMessageList);
	
	var MessageListDirective = function MessageListDirective() {
		_classCallCheck(this, MessageListDirective);
	
		this.template = _templatesMessageListHtml2["default"];
		this.restrict = "E";
		this.replace = true;
		this.controller = _controllersMessageList2["default"];
		this.controllerAs = "messageListCtrl";
	};
	
	exports["default"] = MessageListDirective;
	module.exports = exports["default"];

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _classCallCheck = __webpack_require__(1)["default"];
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _templatesSideNavHtml = __webpack_require__(160);
	
	var _templatesSideNavHtml2 = _interopRequireDefault(_templatesSideNavHtml);
	
	var _controllersSideNav = __webpack_require__(77);
	
	var _controllersSideNav2 = _interopRequireDefault(_controllersSideNav);
	
	__webpack_require__(138);
	
	var SideNavDirective = function SideNavDirective() {
		_classCallCheck(this, SideNavDirective);
	
		this.template = _templatesSideNavHtml2["default"];
		this.restrict = "E";
		this.controller = _controllersSideNav2["default"];
		this.controllerAs = "sideNavCtrl";
	};
	
	exports["default"] = SideNavDirective;
	module.exports = exports["default"];

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _classCallCheck = __webpack_require__(1)["default"];
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _templatesTaskDropdownHtml = __webpack_require__(161);
	
	var _templatesTaskDropdownHtml2 = _interopRequireDefault(_templatesTaskDropdownHtml);
	
	var _controllersTaskList = __webpack_require__(78);
	
	var _controllersTaskList2 = _interopRequireDefault(_controllersTaskList);
	
	var TaskDropdownDirective = function TaskDropdownDirective() {
		_classCallCheck(this, TaskDropdownDirective);
	
		this.template = _templatesTaskDropdownHtml2["default"];
		this.restrict = "E";
		this.replace = true;
		this.controller = _controllersTaskList2["default"];
		this.controllerAs = "taskListCtrl";
	};
	
	exports["default"] = TaskDropdownDirective;
	module.exports = exports["default"];

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _classCallCheck = __webpack_require__(1)["default"];
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _templatesTopNavHtml = __webpack_require__(162);
	
	var _templatesTopNavHtml2 = _interopRequireDefault(_templatesTopNavHtml);
	
	__webpack_require__(139);
	
	var TopNavDirective = function TopNavDirective() {
		_classCallCheck(this, TopNavDirective);
	
		this.template = _templatesTopNavHtml2["default"];
		this.restrict = "E";
	};
	
	exports["default"] = TopNavDirective;
	module.exports = exports["default"];

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _directivesTopNav = __webpack_require__(84);
	
	var _directivesTopNav2 = _interopRequireDefault(_directivesTopNav);
	
	var _directivesMessageDropdown = __webpack_require__(80);
	
	var _directivesMessageDropdown2 = _interopRequireDefault(_directivesMessageDropdown);
	
	var _directivesTaskDropdown = __webpack_require__(83);
	
	var _directivesTaskDropdown2 = _interopRequireDefault(_directivesTaskDropdown);
	
	var _directivesAlertDropdown = __webpack_require__(79);
	
	var _directivesAlertDropdown2 = _interopRequireDefault(_directivesAlertDropdown);
	
	var _directivesSideNav = __webpack_require__(82);
	
	var _directivesSideNav2 = _interopRequireDefault(_directivesSideNav);
	
	var _directivesMessageList = __webpack_require__(81);
	
	var _directivesMessageList2 = _interopRequireDefault(_directivesMessageList);
	
	exports["default"] = angular.module("modules.portal", []).directive("snTopNav", function () {
		return new _directivesTopNav2["default"]();
	}).directive("snMessageDropdown", function () {
		return new _directivesMessageDropdown2["default"]();
	}).directive("snTaskDropdown", function () {
		return new _directivesTaskDropdown2["default"]();
	}).directive("snAlertDropdown", function () {
		return new _directivesAlertDropdown2["default"]();
	}).directive("snSideNav", function () {
		return new _directivesSideNav2["default"]();
	}).directive("snMessageList", function () {
		return new _directivesMessageList2["default"]();
	}).name;
	module.exports = exports["default"];

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = __webpack_require__(3)["default"];
	
	var _classCallCheck = __webpack_require__(1)["default"];
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var ChatService = (function () {
		function ChatService($http, $q) {
			_classCallCheck(this, ChatService);
	
			this.$http = $http;
			this.$q = $q;
	
			this.chatList = [];
		}
	
		_createClass(ChatService, [{
			key: "getChatList",
			value: function getChatList() {
				this.chatList = [{
					from: "Tom",
					content: "asfsdfds fsdfdsfds",
					date: new Date(2015, 7, 1)
				}, {
					from: "Jerry",
					content: "asfsdfds fsdfdsfds",
					date: new Date(new Date().valueOf() - 3600000)
				}, {
					from: "Donald",
					content: "asfsdfds fsdfdsfds",
					date: new Date(new Date().valueOf() - 1500)
				}, {
					from: "Droppy",
					content: "asfsdfds fsdfdsfds",
					date: new Date(new Date().valueOf() - 1500)
				}];
	
				var defer = this.$q.defer();
				defer.resolve(this.chatList);
				return defer.promise;
			}
		}, {
			key: "sendMessage",
			value: function sendMessage(message) {
				this.chatList.push({
					from: "Sun Wukong",
					content: message,
					date: new Date()
				});
			}
		}]);
	
		return ChatService;
	})();
	
	exports["default"] = ChatService;
	
	ChatService.$inject = ["$http", "$q"];
	module.exports = exports["default"];

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = __webpack_require__(3)["default"];
	
	var _classCallCheck = __webpack_require__(1)["default"];
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var DashboardService = (function () {
		function DashboardService($http, $q) {
			_classCallCheck(this, DashboardService);
	
			this.$http = $http;
			this.$q = $q;
	
			this.messageList = [];
			this.taskList = [];
			this.alertList = [];
			this.menuList = [];
		}
	
		_createClass(DashboardService, [{
			key: "getMessageList",
			value: function getMessageList() {
				this.messageList = [{
					title: "Message 1",
					content: "asfsdfds fsdfdsfds",
					date: new Date(2015, 7, 1)
				}, {
					title: "Message 2",
					content: "asfsdfds fsdfdsfds",
					date: new Date(new Date().valueOf() - 3600000)
				}, {
					title: "Message 3",
					content: "asfsdfds fsdfdsfds",
					date: new Date(new Date().valueOf() - 1500)
				}];
	
				var defer = this.$q.defer();
				defer.resolve(this.messageList);
				return defer.promise;
			}
		}, {
			key: "getTaskList",
			value: function getTaskList() {
				this.taskList = [{
					name: "Task 1",
					percentage: 40
				}, {
					name: "Task 2",
					percentage: 100
				}, {
					name: "Task 3",
					percentage: 60
				}, {
					name: "Task 4",
					percentage: 20
				}, {
					name: "Task 5",
					percentage: 80
				}];
	
				var defer = this.$q.defer();
				defer.resolve(this.taskList);
				return defer.promise;
			}
		}, {
			key: "getAlertList",
			value: function getAlertList() {
				this.alertList = [{
					type: "comment",
					content: "asfsdfds fsdfdsfds",
					date: new Date(2015, 7, 1)
				}, {
					type: "twitter",
					content: "asfsdfds fsdfdsfds",
					date: new Date(new Date().valueOf() - 3600000)
				}, {
					type: "envelope",
					content: "asfsdfds fsdfdsfds",
					date: new Date(new Date().valueOf() - 15000)
				}, {
					type: "tasks",
					content: "asfsdfds fsdfdsfds",
					date: new Date(new Date().valueOf() - 150000)
				}, {
					type: "upload",
					content: "asfsdfds fsdfdsfds",
					date: new Date(new Date().valueOf() - 500000)
				}];
	
				var defer = this.$q.defer();
				defer.resolve(this.alertList);
				return defer.promise;
			}
		}, {
			key: "getMenuList",
			value: function getMenuList() {
				this.menuList = [{ code: "0", name: "Dashboard", icon: "fa-dashboard", state: "Dashboard" }, { code: "1", name: "Charts", icon: "fa-bar-chart-o" }, { code: "2", name: "Messages", icon: "fa-table", state: "Messages" }, { code: "3", name: "Forms", icon: "fa-edit" }, { code: "4", name: "UI Elements", icon: "fa-wrench" }, { code: "5", name: "Multi-Level Dropdown", icon: "fa-sitemap" }, { code: "6", name: "Sample Pages", icon: "fa-files-o" }, { code: "10", parent: "1", name: "Flot Charts" }, { code: "11", parent: "1", name: "Morris.js Charts" }, { code: "40", parent: "4", name: "Panels and Wells" }, { code: "41", parent: "4", name: "Buttons" }, { code: "42", parent: "4", name: "Notifications" }, { code: "43", parent: "4", name: "Typography" }, { code: "44", parent: "4", name: "Icons" }, { code: "45", parent: "4", name: "Grid" }, { code: "50", parent: "5", name: "Second Level Item" }, { code: "51", parent: "5", name: "Second Level Item" }, { code: "52", parent: "5", name: "Third Level" }, { code: "60", parent: "6", name: "Blank Page" }, { code: "61", parent: "6", name: "Login Page" }, { code: "520", parent: "52", name: "Third Level Item" }, { code: "521", parent: "52", name: "Third Level Item" }, { code: "522", parent: "52", name: "Third Level Item" }, { code: "523", parent: "52", name: "Third Level Item" }];
	
				var defer = this.$q.defer();
				defer.resolve(this.menuList);
				return defer.promise;
			}
		}]);
	
		return DashboardService;
	})();
	
	exports["default"] = DashboardService;
	
	DashboardService.$inject = ["$http", "$q"];
	module.exports = exports["default"];

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _dashboard = __webpack_require__(87);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _chat = __webpack_require__(86);
	
	var _chat2 = _interopRequireDefault(_chat);
	
	var _timeline = __webpack_require__(90);
	
	var _timeline2 = _interopRequireDefault(_timeline);
	
	var _notification = __webpack_require__(89);
	
	var _notification2 = _interopRequireDefault(_notification);
	
	exports["default"] = angular.module("services.dashboard", []).service("DashboardService", _dashboard2["default"]).service("ChatService", _chat2["default"]).service("TimelineService", _timeline2["default"]).service("NotificationService", _notification2["default"]).name;
	module.exports = exports["default"];

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = __webpack_require__(3)["default"];
	
	var _classCallCheck = __webpack_require__(1)["default"];
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var NotificationService = (function () {
		function NotificationService($http, $q) {
			_classCallCheck(this, NotificationService);
	
			this.$http = $http;
			this.$q = $q;
	
			this.notifications = [];
		}
	
		_createClass(NotificationService, [{
			key: "getNotifications",
			value: function getNotifications() {
				this.notifications = [{
					type: "comment",
					content: "asfsdfds fsdfdsfds",
					date: new Date(2015, 7, 1)
				}, {
					type: "twitter",
					content: "asfsdfds fsdfdsfds",
					date: new Date(new Date().valueOf() - 3600000)
				}, {
					type: "envelope",
					content: "asfsdfds fsdfdsfds",
					date: new Date(new Date().valueOf() - 15000)
				}, {
					type: "tasks",
					content: "asfsdfds fsdfdsfds",
					date: new Date(new Date().valueOf() - 150000)
				}, {
					type: "upload",
					content: "asfsdfds fsdfdsfds",
					date: new Date(new Date().valueOf() - 500000)
				}];
	
				var defer = this.$q.defer();
				defer.resolve(this.notifications);
				return defer.promise;
			}
		}]);
	
		return NotificationService;
	})();
	
	exports["default"] = NotificationService;
	
	NotificationService.$inject = ["$http", "$q"];
	module.exports = exports["default"];

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = __webpack_require__(3)["default"];
	
	var _classCallCheck = __webpack_require__(1)["default"];
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var TimelineService = (function () {
		function TimelineService($http, $q) {
			_classCallCheck(this, TimelineService);
	
			this.$http = $http;
			this.$q = $q;
	
			this.timeline = [];
		}
	
		_createClass(TimelineService, [{
			key: "getTimeline",
			value: function getTimeline() {
				this.timeline = [{
					title: "Tom",
					content: "asfsdfds fsdfdsfds",
					date: new Date(2015, 7, 1)
				}, {
					title: "Jerry",
					content: "asfsdfds fsdfdsfds",
					date: new Date(new Date().valueOf() - 3600000)
				}, {
					title: "Donald",
					content: "asfsdfds fsdfdsfds",
					date: new Date(new Date().valueOf() - 1500)
				}, {
					title: "Droppy",
					content: "asfsdfds fsdfdsfds",
					date: new Date(new Date().valueOf() - 1500)
				}];
	
				var defer = this.$q.defer();
				defer.resolve(this.timeline);
				return defer.promise;
			}
		}]);
	
		return TimelineService;
	})();
	
	exports["default"] = TimelineService;
	
	TimelineService.$inject = ["$http", "$q"];
	module.exports = exports["default"];

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = __webpack_require__(3)["default"];
	
	var _classCallCheck = __webpack_require__(1)["default"];
	
	var _Array$from = __webpack_require__(100)["default"];
	
	var _Object$create = __webpack_require__(22)["default"];
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var EmployeeService = (function () {
		function EmployeeService($http, $q) {
			_classCallCheck(this, EmployeeService);
	
			this.$http = $http;
			this.$q = $q;
	
			this.employeeList = _Array$from(Array(188), function (v, k) {
				return _Object$create({
					name: "Employee " + k,
					age: 18 + Math.floor(Math.random() * 20),
					gender: Math.round(Math.random())
				});
			});
		}
	
		_createClass(EmployeeService, [{
			key: "getEmployeeList",
			value: function getEmployeeList(pageIndex, pageSize) {
				var employeeList = this.employeeList.slice(pageIndex * pageSize, pageIndex * pageSize + pageSize);
	
				var defer = this.$q.defer();
				defer.resolve({
					total: this.employeeList.length,
					employeeList: employeeList
				});
				return defer.promise;
			}
		}, {
			key: "addEmployee",
			value: function addEmployee(employee) {
				this.employeeList.push(employee);
	
				var defer = this.$q.defer();
				defer.resolve(employee);
				return defer.promise;
			}
		}, {
			key: "deleteEmployee",
			value: function deleteEmployee(employee) {
				this.employeeList = this.employeeList.filter(function (it) {
					return it == employee;
				});
	
				var defer = this.$q.defer();
				defer.resolve();
				return defer.promise;
			}
		}]);
	
		return EmployeeService;
	})();
	
	exports["default"] = EmployeeService;
	
	EmployeeService.$inject = ["$http", "$q"];
	module.exports = exports["default"];

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _employee = __webpack_require__(91);
	
	var _employee2 = _interopRequireDefault(_employee);
	
	exports["default"] = angular.module("services.employee", []).service("EmployeeService", _employee2["default"]).name;
	module.exports = exports["default"];

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _portalIndex = __webpack_require__(97);
	
	var _portalIndex2 = _interopRequireDefault(_portalIndex);
	
	var _dashboardIndex = __webpack_require__(88);
	
	var _dashboardIndex2 = _interopRequireDefault(_dashboardIndex);
	
	var _platformIndex = __webpack_require__(96);
	
	var _platformIndex2 = _interopRequireDefault(_platformIndex);
	
	var _employeeIndex = __webpack_require__(92);
	
	var _employeeIndex2 = _interopRequireDefault(_employeeIndex);
	
	exports["default"] = angular.module("services", [_portalIndex2["default"], _dashboardIndex2["default"], _platformIndex2["default"], _employeeIndex2["default"]]).name;
	module.exports = exports["default"];

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = __webpack_require__(3)["default"];
	
	var _classCallCheck = __webpack_require__(1)["default"];
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var EntityService = (function () {
		function EntityService($http, $q) {
			_classCallCheck(this, EntityService);
	
			this.$http = $http;
			this.$q = $q;
	
			this.entityList = [{ name: "User" }, { name: "Order" }];
		}
	
		_createClass(EntityService, [{
			key: "getEntityList",
			value: function getEntityList() {
				var defer = this.$q.defer();
				defer.resolve(this.entityList);
				return defer.promise;
			}
		}, {
			key: "addEntity",
			value: function addEntity(entity) {
				this.entityList.push(entity);
	
				var defer = this.$q.defer();
				defer.resolve(entity);
				return defer.promise;
			}
		}, {
			key: "deleteEntity",
			value: function deleteEntity(entity) {
				this.entityList = this.entityList.filter(function (it) {
					return it != entity;
				});
	
				var defer = this.$q.defer();
				defer.resolve();
				return defer.promise;
			}
		}, {
			key: "getPropertiesByEntity",
			value: function getPropertiesByEntity(entity) {
				var properties = [{ name: "id", type: "uuid", required: true, isPrimaryKey: true }, { name: "name", type: "string", required: true, isPrimaryKey: false }, { name: "gender", type: "int", required: true, isPrimaryKey: false }, { name: "age", type: "int", required: true, isPrimaryKey: false }];
	
				var defer = this.$q.defer();
				defer.resolve(properties);
				return defer.promise;
			}
		}, {
			key: "addProperty",
			value: function addProperty(entity, property) {}
		}, {
			key: "modifyProperty",
			value: function modifyProperty(property) {}
		}, {
			key: "deleteProperty",
			value: function deleteProperty(property) {}
		}, {
			key: "getRulesByEntity",
			value: function getRulesByEntity(entity) {
				var rules = [{ name: "getFullName", returnType: "string", params: [{ name: "firstName", type: "string" }, { name: "lastName", type: "string" }], body: "return firstName + lastName;" }, { name: "ageIsValid", returnType: "boolean", params: [], body: "return this.age > 0" }];
	
				var defer = this.$q.defer();
				defer.resolve(rules);
				return defer.promise;
			}
		}, {
			key: "addRule",
			value: function addRule(entity, rule) {}
		}, {
			key: "modifyRule",
			value: function modifyRule(rule) {}
		}, {
			key: "deleteRule",
			value: function deleteRule(rule) {}
		}]);
	
		return EntityService;
	})();
	
	exports["default"] = EntityService;
	
	EntityService.$inject = ["$http", "$q"];
	module.exports = exports["default"];

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = __webpack_require__(3)["default"];
	
	var _classCallCheck = __webpack_require__(1)["default"];
	
	var _get = __webpack_require__(105)["default"];
	
	var _inherits = __webpack_require__(106)["default"];
	
	var _Map = __webpack_require__(101)["default"];
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var FlowService = (function () {
		function FlowService($http, $q) {
			_classCallCheck(this, FlowService);
	
			this.$http = $http;
			this.$q = $q;
	
			this.flowList = [];
		}
	
		_createClass(FlowService, [{
			key: "getFlowList",
			value: function getFlowList() {
				var defer = this.$q.defer();
				defer.resolve(this.flowList);
				return defer.promise;
			}
		}, {
			key: "getFlow",
			value: function getFlow(data) {
				var defer = this.$q.defer();
				var flow = createFlow(data);
				defer.resolve(flow);
				return defer.promise;
			}
		}, {
			key: "getAnotherFlow",
			value: function getAnotherFlow() {
				var defer = this.$q.defer();
				var flow = createFlow({
					name: "Euclid",
					activities: [{ id: "a00", type: "start", action: "this.a=72; this.b=45;" }, { id: "a01", type: "normal", action: "var temp=this.a%this.b; this.a=this.b; this.b=temp;" }, { id: "a02", type: "finish", action: "alert(this.b);" }],
					transitions: [{ id: "b00", from: "a00", to: "a01", condition: "return true" }, { id: "b01", from: "a01", to: "a01", condition: "return this.a%this.b!=0" }, { id: "b02", from: "a01", to: "a02", condition: "return this.a%this.b==0" }]
				});
				defer.resolve(flow);
				return defer.promise;
			}
		}]);
	
		return FlowService;
	})();
	
	exports["default"] = FlowService;
	
	FlowService.$inject = ["$http", "$q"];
	
	function createFlow(data) {
		var flow = new StateMachine();
	
		flow.load(data);
	
		return flow;
	}
	
	var Flow = (function () {
		function Flow() {
			_classCallCheck(this, Flow);
	
			this.context = {};
	
			this.activityMap = new _Map();
			this.transitionMap = new _Map();
	
			this.finished = false;
		}
	
		_createClass(Flow, [{
			key: "execute",
			value: function execute() {
				while (!this.finished) {
					this.executeStep();
				}
			}
		}, {
			key: "executeStep",
			value: function executeStep() {
				if (this.finished) {
					return;
				}
	
				// sync
				this.currentActivity.execute();
	
				if (this.currentActivity == this.tail) {
					this.finished = true;
				}
	
				for (var i = 0; i < this.currentActivity.out.length; i++) {
					var transition = this.currentActivity.out[i];
					if (transition.evaluate()) {
						this.currentActivity = transition.to;
						break;
					}
				};
			}
		}]);
	
		return Flow;
	})();
	
	var StateMachine = (function (_Flow) {
		_inherits(StateMachine, _Flow);
	
		function StateMachine() {
			_classCallCheck(this, StateMachine);
	
			_get(Object.getPrototypeOf(StateMachine.prototype), "constructor", this).call(this);
		}
	
		_createClass(StateMachine, [{
			key: "load",
			value: function load(flow) {
				var _this = this;
	
				flow.activities.forEach(function (data) {
					return _this.addActivity(data);
				});
				flow.transitions.forEach(function (data) {
					return _this.addTransition(data);
				});
	
				this.currentActivity = this.head;
			}
		}, {
			key: "addActivity",
			value: function addActivity(data) {
				var activity = new Activity(data);
				activity.context = this.context;
				this.activityMap.set(data.id, activity);
	
				if (data.type == "start") {
					this.head = activity;
				}
	
				if (data.type == "finish") {
					this.tail = activity;
				}
	
				return activity;
			}
		}, {
			key: "addTransition",
			value: function addTransition(data) {
				var from = this.activityMap.get(data.from);
				var to = this.activityMap.get(data.to);
	
				var transition = new Transition(from, to, data);
				transition.context = this.context;
				this.transitionMap.set(data.id, transition);
	
				from.out.push(transition);
				to["in"].push(transition);
	
				return transition;
			}
		}]);
	
		return StateMachine;
	})(Flow);
	
	var SequntialFlow = (function (_Flow2) {
		_inherits(SequntialFlow, _Flow2);
	
		function SequntialFlow() {
			_classCallCheck(this, SequntialFlow);
	
			_get(Object.getPrototypeOf(SequntialFlow.prototype), "constructor", this).apply(this, arguments);
		}
	
		return SequntialFlow;
	})(Flow);
	
	var Activity = (function () {
		function Activity(data) {
			_classCallCheck(this, Activity);
	
			this["in"] = [];
			this.out = [];
	
			this.action = new Function(data.action);
		}
	
		_createClass(Activity, [{
			key: "execute",
			value: function execute() {
				this.action.call(this.context);
			}
		}]);
	
		return Activity;
	})();
	
	var Transition = (function () {
		// condition理论上需要支持几种东西：
		// 1. 当前上下文中，变量的算术和逻辑运算
		// 2. 当前上下文中，同步方法的调用（在这里支持异步，既麻烦又无必要）
	
		function Transition(from, to, data) {
			_classCallCheck(this, Transition);
	
			this.from = from;
			this.to = to;
	
			this.condition = new Function(data.condition);
		}
	
		_createClass(Transition, [{
			key: "evaluate",
			value: function evaluate() {
				return this.condition.call(this.context);
			}
		}]);
	
		return Transition;
	})();

	module.exports = exports["default"];

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _entity = __webpack_require__(94);
	
	var _entity2 = _interopRequireDefault(_entity);
	
	var _flow = __webpack_require__(95);
	
	var _flow2 = _interopRequireDefault(_flow);
	
	exports["default"] = angular.module("services.entity", []).service("EntityService", _entity2["default"]).service("FlowService", _flow2["default"]).name;
	module.exports = exports["default"];

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(2)["default"];
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _portal = __webpack_require__(98);
	
	var _portal2 = _interopRequireDefault(_portal);
	
	var _router = __webpack_require__(99);
	
	var _router2 = _interopRequireDefault(_router);
	
	exports["default"] = angular.module("services.portal", []).service("PortalService", _portal2["default"]).service("RouterService", _router2["default"]).name;
	module.exports = exports["default"];

/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = __webpack_require__(3)["default"];
	
	var _classCallCheck = __webpack_require__(1)["default"];
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var PortalService = (function () {
		function PortalService($http, $q) {
			_classCallCheck(this, PortalService);
	
			this.$http = $http;
			this.$q = $q;
	
			this.messageList = [];
			this.taskList = [];
			this.alertList = [];
			this.menuList = [];
		}
	
		_createClass(PortalService, [{
			key: "getMessageList",
			value: function getMessageList() {
				this.messageList = [{
					title: "Message 1",
					content: "asfsdfds fsdfdsfds",
					date: new Date(2015, 7, 1)
				}, {
					title: "Message 2",
					content: "asfsdfds fsdfdsfds",
					date: new Date(new Date().valueOf() - 3600000)
				}, {
					title: "Message 3",
					content: "asfsdfds fsdfdsfds",
					date: new Date(new Date().valueOf() - 1500)
				}];
	
				var defer = this.$q.defer();
				defer.resolve(this.messageList);
				return defer.promise;
			}
		}, {
			key: "getTaskList",
			value: function getTaskList() {
				this.taskList = [{
					name: "Task 1",
					percentage: 40
				}, {
					name: "Task 2",
					percentage: 100
				}, {
					name: "Task 3",
					percentage: 60
				}, {
					name: "Task 4",
					percentage: 20
				}, {
					name: "Task 5",
					percentage: 80
				}];
	
				var defer = this.$q.defer();
				defer.resolve(this.taskList);
				return defer.promise;
			}
		}, {
			key: "getAlertList",
			value: function getAlertList() {
				this.alertList = [{
					type: "comment",
					content: "asfsdfds fsdfdsfds",
					date: new Date(2015, 7, 1)
				}, {
					type: "twitter",
					content: "asfsdfds fsdfdsfds",
					date: new Date(new Date().valueOf() - 3600000)
				}, {
					type: "envelope",
					content: "asfsdfds fsdfdsfds",
					date: new Date(new Date().valueOf() - 15000)
				}, {
					type: "tasks",
					content: "asfsdfds fsdfdsfds",
					date: new Date(new Date().valueOf() - 150000)
				}, {
					type: "upload",
					content: "asfsdfds fsdfdsfds",
					date: new Date(new Date().valueOf() - 500000)
				}];
	
				var defer = this.$q.defer();
				defer.resolve(this.alertList);
				return defer.promise;
			}
		}, {
			key: "getMenuList",
			value: function getMenuList() {
				this.menuList = [{ code: "0", name: "Dashboard", icon: "fa-dashboard", state: "Dashboard" }, { code: "1", name: "Platform", icon: "fa-bar-chart-o", state: "Platform" }, { code: "2", name: "Messages", icon: "fa-table", state: "Messages" }, { code: "3", name: "Employees", icon: "fa-user", state: "Employees" }, { code: "4", name: "UI Elements", icon: "fa-wrench", state: "UI Elements" }, { code: "5", name: "Demos", icon: "fa-sitemap", state: "Demos" }, { code: "6", name: "Sample Pages", icon: "fa-files-o", state: "Sample Pages" }, { code: "10", parent: "1", name: "Entity Management", state: "Entity" }, { code: "11", parent: "1", name: "Rule Management" }, { code: "12", parent: "1", name: "Workflow Management", state: "Flow" }, { code: "13", parent: "1", name: "UI Builder" }, { code: "40", parent: "4", name: "Panels and Wells" }, { code: "41", parent: "4", name: "Buttons" }, { code: "42", parent: "4", name: "Notifications" }, { code: "43", parent: "4", name: "Typography" }, { code: "44", parent: "4", name: "Icons" }, { code: "45", parent: "4", name: "Grid" }, { code: "50", parent: "5", name: "Demo1" }, { code: "51", parent: "5", name: "Demo2" }, { code: "52", parent: "5", name: "Workflow Demo" }, { code: "60", parent: "6", name: "Blank Page" }, { code: "61", parent: "6", name: "Login Page" }, { code: "520", parent: "52", name: "Euclid", state: "Euclid" }, { code: "521", parent: "52", name: "Choice", state: "Choice" }, { code: "522", parent: "52", name: "Third Level Item" }, { code: "523", parent: "52", name: "Third Level Item" }];
	
				var defer = this.$q.defer();
				defer.resolve(this.menuList);
				return defer.promise;
			}
		}]);
	
		return PortalService;
	})();
	
	exports["default"] = PortalService;
	
	PortalService.$inject = ["$http", "$q"];
	module.exports = exports["default"];

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _createClass = __webpack_require__(3)["default"];
	
	var _classCallCheck = __webpack_require__(1)["default"];
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var RouterService = (function () {
		function RouterService($state) {
			_classCallCheck(this, RouterService);
	
			this.$state = $state;
		}
	
		_createClass(RouterService, [{
			key: "go",
			value: function go(state) {
				this.$state.go(state);
			}
		}]);
	
		return RouterService;
	})();
	
	exports["default"] = RouterService;
	
	RouterService.$inject = ["$state"];
	module.exports = exports["default"];

/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(107), __esModule: true };

/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(108), __esModule: true };

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(110), __esModule: true };

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(111), __esModule: true };

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(112), __esModule: true };

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _Object$getOwnPropertyDescriptor = __webpack_require__(103)["default"];
	
	exports["default"] = function get(_x, _x2, _x3) {
	  var _again = true;
	
	  _function: while (_again) {
	    var object = _x,
	        property = _x2,
	        receiver = _x3;
	    desc = parent = getter = undefined;
	    _again = false;
	    if (object === null) object = Function.prototype;
	
	    var desc = _Object$getOwnPropertyDescriptor(object, property);
	
	    if (desc === undefined) {
	      var parent = Object.getPrototypeOf(object);
	
	      if (parent === null) {
	        return undefined;
	      } else {
	        _x = parent;
	        _x2 = property;
	        _x3 = receiver;
	        _again = true;
	        continue _function;
	      }
	    } else if ("value" in desc) {
	      return desc.value;
	    } else {
	      var getter = desc.get;
	
	      if (getter === undefined) {
	        return undefined;
	      }
	
	      return getter.call(receiver);
	    }
	  }
	};
	
	exports.__esModule = true;

/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _Object$create = __webpack_require__(22)["default"];
	
	var _Object$setPrototypeOf = __webpack_require__(104)["default"];
	
	exports["default"] = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }
	
	  subClass.prototype = _Object$create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _Object$setPrototypeOf ? _Object$setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};
	
	exports.__esModule = true;

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(37);
	__webpack_require__(127);
	module.exports = __webpack_require__(6).Array.from;

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(132);
	__webpack_require__(37);
	__webpack_require__(134);
	__webpack_require__(129);
	__webpack_require__(133);
	module.exports = __webpack_require__(6).Map;

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(4);
	module.exports = function create(P, D){
	  return $.create(P, D);
	};

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(4);
	module.exports = function defineProperty(it, key, desc){
	  return $.setDesc(it, key, desc);
	};

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(4);
	__webpack_require__(131);
	module.exports = function getOwnPropertyDescriptor(it, key){
	  return $.getDesc(it, key);
	};

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(130);
	module.exports = __webpack_require__(6).Object.setPrototypeOf;

/***/ },
/* 113 */
/***/ function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $            = __webpack_require__(4)
	  , hide         = __webpack_require__(8)
	  , ctx          = __webpack_require__(11)
	  , species      = __webpack_require__(124)
	  , strictNew    = __webpack_require__(32)
	  , defined      = __webpack_require__(16)
	  , forOf        = __webpack_require__(17)
	  , step         = __webpack_require__(28)
	  , ID           = __webpack_require__(35)('id')
	  , $has         = __webpack_require__(18)
	  , isObject     = __webpack_require__(12)
	  , isExtensible = Object.isExtensible || isObject
	  , SUPPORT_DESC = __webpack_require__(13)
	  , SIZE         = SUPPORT_DESC ? '_s' : 'size'
	  , id           = 0;
	
	function fastKey(it, create){
	  // return primitive with prefix
	  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if(!$has(it, ID)){
	    // can't set id to frozen object
	    if(!isExtensible(it))return 'F';
	    // not necessary to add id
	    if(!create)return 'E';
	    // add missing object id
	    hide(it, ID, ++id);
	  // return object id with prefix
	  } return 'O' + it[ID];
	}
	
	function getEntry(that, key){
	  // fast case
	  var index = fastKey(key), entry;
	  if(index !== 'F')return that._i[index];
	  // frozen object case
	  for(entry = that._f; entry; entry = entry.n){
	    if(entry.k == key)return entry;
	  }
	}
	
	module.exports = {
	  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
	    var C = wrapper(function(that, iterable){
	      strictNew(that, C, NAME);
	      that._i = $.create(null); // index
	      that._f = undefined;      // first entry
	      that._l = undefined;      // last entry
	      that[SIZE] = 0;           // size
	      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    __webpack_require__(29)(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear(){
	        for(var that = this, data = that._i, entry = that._f; entry; entry = entry.n){
	          entry.r = true;
	          if(entry.p)entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function(key){
	        var that  = this
	          , entry = getEntry(that, key);
	        if(entry){
	          var next = entry.n
	            , prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if(prev)prev.n = next;
	          if(next)next.p = prev;
	          if(that._f == entry)that._f = next;
	          if(that._l == entry)that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /*, that = undefined */){
	        var f = ctx(callbackfn, arguments[1], 3)
	          , entry;
	        while(entry = entry ? entry.n : this._f){
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while(entry && entry.r)entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key){
	        return !!getEntry(this, key);
	      }
	    });
	    if(SUPPORT_DESC)$.setDesc(C.prototype, 'size', {
	      get: function(){
	        return defined(this[SIZE]);
	      }
	    });
	    return C;
	  },
	  def: function(that, key, value){
	    var entry = getEntry(that, key)
	      , prev, index;
	    // change existing entry
	    if(entry){
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if(!that._f)that._f = entry;
	      if(prev)prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if(index !== 'F')that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function(C, NAME, IS_MAP){
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    __webpack_require__(19)(C, NAME, function(iterated, kind){
	      this._t = iterated;  // target
	      this._k = kind;      // kind
	      this._l = undefined; // previous
	    }, function(){
	      var that  = this
	        , kind  = that._k
	        , entry = that._l;
	      // revert to the last existing entry
	      while(entry && entry.r)entry = entry.p;
	      // get next entry
	      if(!that._t || !(that._l = entry = entry ? entry.n : that._t._f)){
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if(kind == 'keys'  )return step(0, entry.k);
	      if(kind == 'values')return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values' , !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    species(C);
	    species(__webpack_require__(6)[NAME]); // for wrapper
	  }
	};

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var forOf   = __webpack_require__(17)
	  , classof = __webpack_require__(23);
	module.exports = function(NAME){
	  return function toJSON(){
	    if(classof(this) != NAME)throw TypeError(NAME + "#toJSON isn't generic");
	    var arr = [];
	    forOf(this, false, arr.push, arr);
	    return arr;
	  };
	};

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $          = __webpack_require__(4)
	  , $def       = __webpack_require__(7)
	  , hide       = __webpack_require__(8)
	  , BUGGY      = __webpack_require__(26)
	  , forOf      = __webpack_require__(17)
	  , strictNew  = __webpack_require__(32);
	
	module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK){
	  var Base  = __webpack_require__(9)[NAME]
	    , C     = Base
	    , ADDER = IS_MAP ? 'set' : 'add'
	    , proto = C && C.prototype
	    , O     = {};
	  if(!__webpack_require__(13) || typeof C != 'function'
	    || !(IS_WEAK || !BUGGY && proto.forEach && proto.entries)){
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    __webpack_require__(29)(C.prototype, methods);
	  } else {
	    C = wrapper(function(target, iterable){
	      strictNew(target, C, NAME);
	      target._c = new Base;
	      if(iterable != undefined)forOf(iterable, IS_MAP, target[ADDER], target);
	    });
	    $.each.call('add,clear,delete,forEach,get,has,set,keys,values,entries'.split(','),function(KEY){
	      var chain = KEY == 'add' || KEY == 'set';
	      if(KEY in proto && !(IS_WEAK && KEY == 'clear'))hide(C.prototype, KEY, function(a, b){
	        var result = this._c[KEY](a === 0 ? 0 : a, b);
	        return chain ? this : result;
	      });
	    });
	    if('size' in proto)$.setDesc(C.prototype, 'size', {
	      get: function(){
	        return this._c.size;
	      }
	    });
	  }
	
	  __webpack_require__(20)(C, NAME);
	
	  O[NAME] = C;
	  $def($def.G + $def.W + $def.F, O);
	
	  if(!IS_WEAK)common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for not array-like ES3 strings
	var cof     = __webpack_require__(24)
	  , $Object = Object;
	module.exports = 0 in $Object('z') ? $Object : function(it){
	  return cof(it) == 'String' ? it.split('') : $Object(it);
	};

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toString = {}.toString
	  , toObject = __webpack_require__(14)
	  , getNames = __webpack_require__(4).getNames;
	
	var windowNames = typeof window == 'object' && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	function getWindowNames(it){
	  try {
	    return getNames(it);
	  } catch(e){
	    return windowNames.slice();
	  }
	}
	
	module.exports.get = function getOwnPropertyNames(it){
	  if(windowNames && toString.call(it) == '[object Window]')return getWindowNames(it);
	  return getNames(toObject(it));
	};

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $ = __webpack_require__(4)
	  , IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(8)(IteratorPrototype, __webpack_require__(5)('iterator'), function(){ return this; });
	
	module.exports = function(Constructor, NAME, next){
	  Constructor.prototype = $.create(IteratorPrototype, {next: __webpack_require__(30)(1,next)});
	  __webpack_require__(20)(Constructor, NAME + ' Iterator');
	};

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	var SYMBOL_ITERATOR = __webpack_require__(5)('iterator')
	  , SAFE_CLOSING    = false;
	try {
	  var riter = [7][SYMBOL_ITERATOR]();
	  riter['return'] = function(){ SAFE_CLOSING = true; };
	  Array.from(riter, function(){ throw 2; });
	} catch(e){ /* empty */ }
	module.exports = function(exec){
	  if(!SAFE_CLOSING)return false;
	  var safe = false;
	  try {
	    var arr  = [7]
	      , iter = arr[SYMBOL_ITERATOR]();
	    iter.next = function(){ safe = true; };
	    arr[SYMBOL_ITERATOR] = function(){ return iter; };
	    exec(arr);
	  } catch(e){ /* empty */ }
	  return safe;
	};

/***/ },
/* 121 */
/***/ function(module, exports) {

	module.exports = true;

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var getDesc  = __webpack_require__(4).getDesc
	  , isObject = __webpack_require__(12)
	  , anObject = __webpack_require__(15);
	function check(O, proto){
	  anObject(O);
	  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
	}
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} // eslint-disable-line
	    ? function(buggy, set){
	        try {
	          set = __webpack_require__(11)(Function.call, getDesc(Object.prototype, '__proto__').set, 2);
	          set({}, []);
	        } catch(e){ buggy = true; }
	        return function setPrototypeOf(O, proto){
	          check(O, proto);
	          if(buggy)O.__proto__ = proto;
	          else set(O, proto);
	          return O;
	        };
	      }()
	    : undefined),
	  check: check
	};

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(9)
	  , SHARED = '__core-js_shared__'
	  , store  = global[SHARED] || (global[SHARED] = {});
	module.exports = function(key){
	  return store[key] || (store[key] = {});
	};

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	var $       = __webpack_require__(4)
	  , SPECIES = __webpack_require__(5)('species');
	module.exports = function(C){
	  if(__webpack_require__(13) && !(SPECIES in C))$.setDesc(C, SPECIES, {
	    configurable: true,
	    get: function(){ return this; }
	  });
	};

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	// true  -> String#at
	// false -> String#codePointAt
	var toInteger = __webpack_require__(33)
	  , defined   = __webpack_require__(16);
	module.exports = function(TO_STRING){
	  return function(that, pos){
	    var s = String(defined(that))
	      , i = toInteger(pos)
	      , l = s.length
	      , a, b;
	    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l
	      || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	        ? TO_STRING ? s.charAt(i) : a
	        : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};

/***/ },
/* 126 */
/***/ function(module, exports) {

	module.exports = function(){ /* empty */ };

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	var ctx         = __webpack_require__(11)
	  , $def        = __webpack_require__(7)
	  , toObject    = __webpack_require__(14)
	  , call        = __webpack_require__(27)
	  , isArrayIter = __webpack_require__(25)
	  , toLength    = __webpack_require__(34)
	  , getIterFn   = __webpack_require__(36);
	$def($def.S + $def.F * !__webpack_require__(120)(function(iter){ Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
	    var O       = toObject(arrayLike, true)
	      , C       = typeof this == 'function' ? this : Array
	      , mapfn   = arguments[1]
	      , mapping = mapfn !== undefined
	      , index   = 0
	      , iterFn  = getIterFn(O)
	      , length, result, step, iterator;
	    if(mapping)mapfn = ctx(mapfn, arguments[2], 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
	      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
	        result[index] = mapping ? call(iterator, mapfn, [step.value, index], true) : step.value;
	      }
	    } else {
	      for(result = new C(length = toLength(O.length)); length > index; index++){
	        result[index] = mapping ? mapfn(O[index], index) : O[index];
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	var setUnscope = __webpack_require__(126)
	  , step       = __webpack_require__(28)
	  , Iterators  = __webpack_require__(10)
	  , toObject   = __webpack_require__(14);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	__webpack_require__(19)(Array, 'Array', function(iterated, kind){
	  this._t = toObject(iterated); // target
	  this._i = 0;                  // next index
	  this._k = kind;               // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function(){
	  var O     = this._t
	    , kind  = this._k
	    , index = this._i++;
	  if(!O || index >= O.length){
	    this._t = undefined;
	    return step(1);
	  }
	  if(kind == 'keys'  )return step(0, index);
	  if(kind == 'values')return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	setUnscope('keys');
	setUnscope('values');
	setUnscope('entries');

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(114);
	
	// 23.1 Map Objects
	__webpack_require__(116)('Map', function(get){
	  return function Map(){ return get(this, arguments[0]); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key){
	    var entry = strong.getEntry(this, key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value){
	    return strong.def(this, key === 0 ? 0 : key, value);
	  }
	}, strong, true);

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $def = __webpack_require__(7);
	$def($def.S, 'Object', {setPrototypeOf: __webpack_require__(122).set});

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	var $        = __webpack_require__(4)
	  , core     = __webpack_require__(6)
	  , $def     = __webpack_require__(7)
	  , toObject = __webpack_require__(14)
	  , isObject = __webpack_require__(12);
	$.each.call(('freeze,seal,preventExtensions,isFrozen,isSealed,isExtensible,' +
	  'getOwnPropertyDescriptor,getPrototypeOf,keys,getOwnPropertyNames').split(',')
	, function(KEY, ID){
	  var fn     = (core.Object || {})[KEY] || Object[KEY]
	    , forced = 0
	    , method = {};
	  method[KEY] = ID == 0 ? function freeze(it){
	    return isObject(it) ? fn(it) : it;
	  } : ID == 1 ? function seal(it){
	    return isObject(it) ? fn(it) : it;
	  } : ID == 2 ? function preventExtensions(it){
	    return isObject(it) ? fn(it) : it;
	  } : ID == 3 ? function isFrozen(it){
	    return isObject(it) ? fn(it) : true;
	  } : ID == 4 ? function isSealed(it){
	    return isObject(it) ? fn(it) : true;
	  } : ID == 5 ? function isExtensible(it){
	    return isObject(it) ? fn(it) : false;
	  } : ID == 6 ? function getOwnPropertyDescriptor(it, key){
	    return fn(toObject(it), key);
	  } : ID == 7 ? function getPrototypeOf(it){
	    return fn(toObject(it, true));
	  } : ID == 8 ? function keys(it){
	    return fn(toObject(it));
	  } : __webpack_require__(118).get;
	  try {
	    fn('z');
	  } catch(e){
	    forced = 1;
	  }
	  $def($def.S + $def.F * forced, 'Object', method);
	});

/***/ },
/* 132 */
/***/ function(module, exports) {



/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $def  = __webpack_require__(7);
	
	$def($def.P, 'Map', {toJSON: __webpack_require__(115)('Map')});

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(128);
	var Iterators = __webpack_require__(10);
	Iterators.NodeList = Iterators.HTMLCollection = Iterators.Array;

/***/ },
/* 135 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 136 */
135,
/* 137 */
135,
/* 138 */
135,
/* 139 */
135,
/* 140 */
/***/ function(module, exports) {

	module.exports = "<div class=\"panel\" ng-class=\"'panel-' + data.theme\">\n\t<div class=\"panel-heading\">\n\t\t<div class=\"row\">\n\t\t\t<div class=\"col-xs-3\">\n\t\t\t\t<i class=\"fa fa-5x\" ng-class=\"data.icon\"></i>\n\t\t\t</div>\n\t\t\t<div class=\"col-xs-9 text-right\">\n\t\t\t\t<div class=\"huge\">{{data.count}}</div>\n\t\t\t\t<div>{{data.content}}</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\t<div class=\"panel-footer\">\n\t\t<span class=\"pull-left\">\n\t\t\t<a ui-sref=\"{{data.state}}\">View Details</a>\n\t\t</span>\n\t\t<span class=\"pull-right\"><i class=\"fa fa-arrow-circle-right\"></i></span>\n\t\t<div class=\"clearfix\"></div>\n\t</div>\n</div>"

/***/ },
/* 141 */
/***/ function(module, exports) {

	module.exports = "<div class=\"panel panel-default\">\n\t<div class=\"panel-heading\">\n\t\t<i class=\"fa fa-bar-chart-o fa-fw\"></i> Area Chart Example\n\t\t<div class=\"pull-right\">\n\t\t\t<div class=\"btn-group\" sn-dropdown>\n\t\t\t\t<button type=\"button\" class=\"btn btn-default btn-xs dropdown-toggle\" data-toggle=\"dropdown\">\n\t\t\t\t\tActions\n\t\t\t\t\t<span class=\"caret\"></span>\n\t\t\t\t</button>\n\t\t\t\t<ul class=\"dropdown-menu pull-right\" role=\"menu\">\n\t\t\t\t\t<li><a href=\"#\">Action</a>\n\t\t\t\t\t</li>\n\t\t\t\t\t<li><a href=\"#\">Another action</a>\n\t\t\t\t\t</li>\n\t\t\t\t\t<li><a href=\"#\">Something else here</a>\n\t\t\t\t\t</li>\n\t\t\t\t\t<li class=\"divider\"></li>\n\t\t\t\t\t<li><a href=\"#\">Separated link</a>\n\t\t\t\t\t</li>\n\t\t\t\t</ul>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\t<!-- /.panel-heading -->\n\t<div class=\"panel-body\">\n\t\t<div id=\"morris-area-chart\" style=\"position: relative; -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\">\n\t\t\t<svg height=\"477\" version=\"1.1\" width=\"700\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n\t\t\tstyle=\"overflow: hidden; position: relative;\">\n\t\t\t\t<desc style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\">Created with Raphaël 2.1.2</desc>\n\t\t\t\t<defs style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\"></defs>\n\t\t\t\t<text x=\"49.0625\" y=\"445\" text-anchor=\"end\" font-family=\"sans-serif\" font-size=\"12px\" stroke=\"none\" fill=\"#888888\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0); text-anchor: end; font-family: sans-serif; font-size: 12px; font-weight: normal;\"\n\t\t\t\tfont-weight=\"normal\">\n\t\t\t\t\t<tspan dy=\"4.25\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\">0</tspan>\n\t\t\t\t</text>\n\t\t\t\t<path fill=\"none\" stroke=\"#aaaaaa\" d=\"M61.5625,445H675\" stroke-width=\"0.5\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\"></path>\n\t\t\t\t<text x=\"49.0625\" y=\"340\" text-anchor=\"end\" font-family=\"sans-serif\" font-size=\"12px\" stroke=\"none\" fill=\"#888888\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0); text-anchor: end; font-family: sans-serif; font-size: 12px; font-weight: normal;\"\n\t\t\t\tfont-weight=\"normal\">\n\t\t\t\t\t<tspan dy=\"4.25\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\">7,500</tspan>\n\t\t\t\t</text>\n\t\t\t\t<path fill=\"none\" stroke=\"#aaaaaa\" d=\"M61.5625,340H675\" stroke-width=\"0.5\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\"></path>\n\t\t\t\t<text x=\"49.0625\" y=\"235\" text-anchor=\"end\" font-family=\"sans-serif\" font-size=\"12px\" stroke=\"none\" fill=\"#888888\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0); text-anchor: end; font-family: sans-serif; font-size: 12px; font-weight: normal;\"\n\t\t\t\tfont-weight=\"normal\">\n\t\t\t\t\t<tspan dy=\"4.25\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\">15,000</tspan>\n\t\t\t\t</text>\n\t\t\t\t<path fill=\"none\" stroke=\"#aaaaaa\" d=\"M61.5625,235H675\" stroke-width=\"0.5\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\"></path>\n\t\t\t\t<text x=\"49.0625\" y=\"130\" text-anchor=\"end\" font-family=\"sans-serif\" font-size=\"12px\" stroke=\"none\" fill=\"#888888\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0); text-anchor: end; font-family: sans-serif; font-size: 12px; font-weight: normal;\"\n\t\t\t\tfont-weight=\"normal\">\n\t\t\t\t\t<tspan dy=\"4.25\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\">22,500</tspan>\n\t\t\t\t</text>\n\t\t\t\t<path fill=\"none\" stroke=\"#aaaaaa\" d=\"M61.5625,130H675\" stroke-width=\"0.5\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\"></path>\n\t\t\t\t<text x=\"49.0625\" y=\"25\" text-anchor=\"end\" font-family=\"sans-serif\" font-size=\"12px\" stroke=\"none\" fill=\"#888888\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0); text-anchor: end; font-family: sans-serif; font-size: 12px; font-weight: normal;\"\n\t\t\t\tfont-weight=\"normal\">\n\t\t\t\t\t<tspan dy=\"4.25\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\">30,000</tspan>\n\t\t\t\t</text>\n\t\t\t\t<path fill=\"none\" stroke=\"#aaaaaa\" d=\"M61.5625,25H675\" stroke-width=\"0.5\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\"></path>\n\t\t\t\t<text x=\"561.7041312272175\" y=\"457.5\" text-anchor=\"middle\" font-family=\"sans-serif\" font-size=\"12px\" stroke=\"none\" fill=\"#888888\"\n\t\t\t\tstyle=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0); text-anchor: middle; font-family: sans-serif; font-size: 12px; font-weight: normal;\"\n\t\t\t\tfont-weight=\"normal\" transform=\"matrix(1,0,0,1,0,6)\">\n\t\t\t\t\t<tspan dy=\"4.25\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\">2012</tspan>\n\t\t\t\t</text>\n\t\t\t\t<text x=\"289.64497266099636\" y=\"457.5\" text-anchor=\"middle\" font-family=\"sans-serif\" font-size=\"12px\" stroke=\"none\" fill=\"#888888\"\n\t\t\t\tstyle=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0); text-anchor: middle; font-family: sans-serif; font-size: 12px; font-weight: normal;\"\n\t\t\t\tfont-weight=\"normal\" transform=\"matrix(1,0,0,1,0,6)\">\n\t\t\t\t\t<tspan dy=\"4.25\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\">2011</tspan>\n\t\t\t\t</text>\n\t\t\t\t<path fill=\"#7cb47c\" stroke=\"none\" d=\"M61.5625,370.618C78.70595382746052,362.918,112.99286148238153,346.93874999999997,130.13631530984205,339.818C147.27976913730257,332.69725,181.56667679222357,323.39997814207646,198.7101306196841,313.652C215.66724255771567,304.0099781420765,249.58146643377887,265.13505801104975,266.53857837181044,262.25800000000004C283.30934842041313,259.4125580110498,316.85088851761844,288.6695,333.62165856622113,290.762C350.76511239368165,292.901,385.0520200486027,277.75949999999995,402.1954738760632,279.18399999999997C419.3389277035237,280.6085,453.6258353584447,327.44467759562843,470.7692891859052,302.158C487.72640112393685,277.14617759562844,521.640625,90.19100000000002,538.5977369380316,77.99000000000001C555.5548488760633,65.789,589.4690727521264,186.6600464480874,606.426184690158,204.54999999999998C623.5696385176185,222.6365464480874,657.8565461725395,217.55949999999999,675,221.896L675,445L61.5625,445Z\"\n\t\t\t\tfill-opacity=\"1\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0); fill-opacity: 1;\"></path>\n\t\t\t\t<path fill=\"none\" stroke=\"#4da74d\" d=\"M61.5625,370.618C78.70595382746052,362.918,112.99286148238153,346.93874999999997,130.13631530984205,339.818C147.27976913730257,332.69725,181.56667679222357,323.39997814207646,198.7101306196841,313.652C215.66724255771567,304.0099781420765,249.58146643377887,265.13505801104975,266.53857837181044,262.25800000000004C283.30934842041313,259.4125580110498,316.85088851761844,288.6695,333.62165856622113,290.762C350.76511239368165,292.901,385.0520200486027,277.75949999999995,402.1954738760632,279.18399999999997C419.3389277035237,280.6085,453.6258353584447,327.44467759562843,470.7692891859052,302.158C487.72640112393685,277.14617759562844,521.640625,90.19100000000002,538.5977369380316,77.99000000000001C555.5548488760633,65.789,589.4690727521264,186.6600464480874,606.426184690158,204.54999999999998C623.5696385176185,222.6365464480874,657.8565461725395,217.55949999999999,675,221.896\"\n\t\t\t\tstroke-width=\"3\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\"></path>\n\t\t\t\t<circle cx=\"61.5625\" cy=\"370.618\" r=\"2\" fill=\"#4da74d\" stroke=\"#ffffff\" stroke-width=\"1\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\"></circle>\n\t\t\t\t<circle cx=\"130.13631530984205\" cy=\"339.818\" r=\"2\" fill=\"#4da74d\" stroke=\"#ffffff\" stroke-width=\"1\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\"></circle>\n\t\t\t\t<circle cx=\"198.7101306196841\" cy=\"313.652\" r=\"2\" fill=\"#4da74d\" stroke=\"#ffffff\" stroke-width=\"1\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\"></circle>\n\t\t\t\t<circle cx=\"266.53857837181044\" cy=\"262.25800000000004\" r=\"2\" fill=\"#4da74d\" stroke=\"#ffffff\" stroke-width=\"1\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\"></circle>\n\t\t\t\t<circle cx=\"333.62165856622113\" cy=\"290.762\" r=\"2\" fill=\"#4da74d\" stroke=\"#ffffff\" stroke-width=\"1\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\"></circle>\n\t\t\t\t<circle cx=\"402.1954738760632\" cy=\"279.18399999999997\" r=\"2\" fill=\"#4da74d\" stroke=\"#ffffff\" stroke-width=\"1\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\"></circle>\n\t\t\t\t<circle cx=\"470.7692891859052\" cy=\"302.158\" r=\"2\" fill=\"#4da74d\" stroke=\"#ffffff\" stroke-width=\"1\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\"></circle>\n\t\t\t\t<circle cx=\"538.5977369380316\" cy=\"77.99000000000001\" r=\"2\" fill=\"#4da74d\" stroke=\"#ffffff\" stroke-width=\"1\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\"></circle>\n\t\t\t\t<circle cx=\"606.426184690158\" cy=\"204.54999999999998\" r=\"2\" fill=\"#4da74d\" stroke=\"#ffffff\" stroke-width=\"1\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\"></circle>\n\t\t\t\t<circle cx=\"675\" cy=\"221.896\" r=\"2\" fill=\"#4da74d\" stroke=\"#ffffff\" stroke-width=\"1\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\"></circle>\n\t\t\t\t<path fill=\"#a7b3bc\" stroke=\"none\" d=\"M61.5625,407.676C78.70595382746052,399.255,112.99286148238153,381.36825,130.13631530984205,373.992C147.27976913730257,366.61575000000005,181.56667679222357,352.6989180327869,198.7101306196841,348.666C215.66724255771567,344.6769180327869,249.58146643377887,345.14706906077345,266.53857837181044,341.904C283.30934842041313,338.69656906077347,316.85088851761844,327.36226923076924,333.62165856622113,322.86400000000003C350.76511239368165,318.26576923076925,385.0520200486027,305.32725000000005,402.1954738760632,305.51800000000003C419.3389277035237,305.70875,453.6258353584447,343.8806775956284,470.7692891859052,324.39C487.72640112393685,305.1111775956284,521.640625,161.87099999999998,538.5977369380316,150.44C555.5548488760633,139.00900000000001,589.4690727521264,220.94168579234972,606.426184690158,232.942C623.5696385176185,245.07418579234974,657.8565461725395,243.463,675,246.97L675,445L61.5625,445Z\"\n\t\t\t\tfill-opacity=\"1\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0); fill-opacity: 1;\"></path>\n\t\t\t\t<path fill=\"none\" stroke=\"#7a92a3\" d=\"M61.5625,407.676C78.70595382746052,399.255,112.99286148238153,381.36825,130.13631530984205,373.992C147.27976913730257,366.61575000000005,181.56667679222357,352.6989180327869,198.7101306196841,348.666C215.66724255771567,344.6769180327869,249.58146643377887,345.14706906077345,266.53857837181044,341.904C283.30934842041313,338.69656906077347,316.85088851761844,327.36226923076924,333.62165856622113,322.86400000000003C350.76511239368165,318.26576923076925,385.0520200486027,305.32725000000005,402.1954738760632,305.51800000000003C419.3389277035237,305.70875,453.6258353584447,343.8806775956284,470.7692891859052,324.39C487.72640112393685,305.1111775956284,521.640625,161.87099999999998,538.5977369380316,150.44C555.5548488760633,139.00900000000001,589.4690727521264,220.94168579234972,606.426184690158,232.942C623.5696385176185,245.07418579234974,657.8565461725395,243.463,675,246.97\"\n\t\t\t\tstroke-width=\"3\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\"></path>\n\t\t\t\t<circle cx=\"61.5625\" cy=\"407.676\" r=\"2\" fill=\"#7a92a3\" stroke=\"#ffffff\" stroke-width=\"1\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\"></circle>\n\t\t\t\t<circle cx=\"130.13631530984205\" cy=\"373.992\" r=\"2\" fill=\"#7a92a3\" stroke=\"#ffffff\" stroke-width=\"1\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\"></circle>\n\t\t\t\t<circle cx=\"198.7101306196841\" cy=\"348.666\" r=\"2\" fill=\"#7a92a3\" stroke=\"#ffffff\" stroke-width=\"1\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\"></circle>\n\t\t\t\t<circle cx=\"266.53857837181044\" cy=\"341.904\" r=\"2\" fill=\"#7a92a3\" stroke=\"#ffffff\" stroke-width=\"1\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\"></circle>\n\t\t\t\t<circle cx=\"333.62165856622113\" cy=\"322.86400000000003\" r=\"2\" fill=\"#7a92a3\" stroke=\"#ffffff\" stroke-width=\"1\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\"></circle>\n\t\t\t\t<circle cx=\"402.1954738760632\" cy=\"305.51800000000003\" r=\"2\" fill=\"#7a92a3\" stroke=\"#ffffff\" stroke-width=\"1\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\"></circle>\n\t\t\t\t<circle cx=\"470.7692891859052\" cy=\"324.39\" r=\"2\" fill=\"#7a92a3\" stroke=\"#ffffff\" stroke-width=\"1\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\"></circle>\n\t\t\t\t<circle cx=\"538.5977369380316\" cy=\"150.44\" r=\"2\" fill=\"#7a92a3\" stroke=\"#ffffff\" stroke-width=\"1\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\"></circle>\n\t\t\t\t<circle cx=\"606.426184690158\" cy=\"232.942\" r=\"2\" fill=\"#7a92a3\" stroke=\"#ffffff\" stroke-width=\"1\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\"></circle>\n\t\t\t\t<circle cx=\"675\" cy=\"246.97\" r=\"2\" fill=\"#7a92a3\" stroke=\"#ffffff\" stroke-width=\"1\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\"></circle>\n\t\t\t\t<path fill=\"#2577b5\" stroke=\"none\" d=\"M61.5625,407.676C78.70595382746052,407.284,112.99286148238153,410.0385,130.13631530984205,406.108C147.27976913730257,402.1775,181.56667679222357,377.9722076502732,198.7101306196841,376.23199999999997C215.66724255771567,374.5107076502732,249.58146643377887,395.60185082872925,266.53857837181044,392.262C283.30934842041313,388.9588508287293,316.85088851761844,352.9536538461538,333.62165856622113,349.65999999999997C350.76511239368165,346.2931538461538,385.0520200486027,362.1375,402.1954738760632,365.62C419.3389277035237,369.1025,453.6258353584447,394.0651693989071,470.7692891859052,377.52C487.72640112393685,361.15466939890706,521.640625,244.24525,538.5977369380316,233.978C555.5548488760633,223.71075000000002,589.4690727521264,283.8237568306011,606.426184690158,295.382C623.5696385176185,307.0672568306011,657.8565461725395,319.0595,675,326.952L675,445L61.5625,445Z\"\n\t\t\t\tfill-opacity=\"1\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0); fill-opacity: 1;\"></path>\n\t\t\t\t<path fill=\"none\" stroke=\"#0b62a4\" d=\"M61.5625,407.676C78.70595382746052,407.284,112.99286148238153,410.0385,130.13631530984205,406.108C147.27976913730257,402.1775,181.56667679222357,377.9722076502732,198.7101306196841,376.23199999999997C215.66724255771567,374.5107076502732,249.58146643377887,395.60185082872925,266.53857837181044,392.262C283.30934842041313,388.9588508287293,316.85088851761844,352.9536538461538,333.62165856622113,349.65999999999997C350.76511239368165,346.2931538461538,385.0520200486027,362.1375,402.1954738760632,365.62C419.3389277035237,369.1025,453.6258353584447,394.0651693989071,470.7692891859052,377.52C487.72640112393685,361.15466939890706,521.640625,244.24525,538.5977369380316,233.978C555.5548488760633,223.71075000000002,589.4690727521264,283.8237568306011,606.426184690158,295.382C623.5696385176185,307.0672568306011,657.8565461725395,319.0595,675,326.952\"\n\t\t\t\tstroke-width=\"3\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\"></path>\n\t\t\t\t<circle cx=\"61.5625\" cy=\"407.676\" r=\"2\" fill=\"#0b62a4\" stroke=\"#ffffff\" stroke-width=\"1\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\"></circle>\n\t\t\t\t<circle cx=\"130.13631530984205\" cy=\"406.108\" r=\"2\" fill=\"#0b62a4\" stroke=\"#ffffff\" stroke-width=\"1\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\"></circle>\n\t\t\t\t<circle cx=\"198.7101306196841\" cy=\"376.23199999999997\" r=\"2\" fill=\"#0b62a4\" stroke=\"#ffffff\" stroke-width=\"1\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\"></circle>\n\t\t\t\t<circle cx=\"266.53857837181044\" cy=\"392.262\" r=\"2\" fill=\"#0b62a4\" stroke=\"#ffffff\" stroke-width=\"1\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\"></circle>\n\t\t\t\t<circle cx=\"333.62165856622113\" cy=\"349.65999999999997\" r=\"2\" fill=\"#0b62a4\" stroke=\"#ffffff\" stroke-width=\"1\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\"></circle>\n\t\t\t\t<circle cx=\"402.1954738760632\" cy=\"365.62\" r=\"2\" fill=\"#0b62a4\" stroke=\"#ffffff\" stroke-width=\"1\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\"></circle>\n\t\t\t\t<circle cx=\"470.7692891859052\" cy=\"377.52\" r=\"2\" fill=\"#0b62a4\" stroke=\"#ffffff\" stroke-width=\"1\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\"></circle>\n\t\t\t\t<circle cx=\"538.5977369380316\" cy=\"233.978\" r=\"2\" fill=\"#0b62a4\" stroke=\"#ffffff\" stroke-width=\"1\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\"></circle>\n\t\t\t\t<circle cx=\"606.426184690158\" cy=\"295.382\" r=\"2\" fill=\"#0b62a4\" stroke=\"#ffffff\" stroke-width=\"1\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\"></circle>\n\t\t\t\t<circle cx=\"675\" cy=\"326.952\" r=\"2\" fill=\"#0b62a4\" stroke=\"#ffffff\" stroke-width=\"1\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\"></circle>\n\t\t\t</svg>\n\t\t\t<div class=\"morris-hover morris-default-style\" style=\"left: 72.1363px; top: 302px; display: none;\">\n\t\t\t\t<div class=\"morris-hover-row-label\">2010 Q2</div>\n\t\t\t\t<div class=\"morris-hover-point\" style=\"color: #0b62a4\">\n\t\t\t\t\tiPhone: 2,778\n\t\t\t\t</div>\n\t\t\t\t<div class=\"morris-hover-point\" style=\"color: #7A92A3\">\n\t\t\t\t\tiPad: 2,294\n\t\t\t\t</div>\n\t\t\t\t<div class=\"morris-hover-point\" style=\"color: #4da74d\">\n\t\t\t\t\tiPod Touch: 2,441\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\t<!-- /.panel-body -->\n</div>\n<!-- /.panel -->"

/***/ },
/* 142 */
/***/ function(module, exports) {

	module.exports = "<div class=\"panel panel-default\">\n\t<div class=\"panel-heading\">\n\t\t<i class=\"fa fa-bar-chart-o fa-fw\"></i> Bar Chart Example\n\t\t<div class=\"pull-right\">\n\t\t\t<div class=\"btn-group\" sn-dropdown>\n\t\t\t\t<button type=\"button\" class=\"btn btn-default btn-xs dropdown-toggle\" data-toggle=\"dropdown\">\n\t\t\t\t\tActions\n\t\t\t\t\t<span class=\"caret\"></span>\n\t\t\t\t</button>\n\t\t\t\t<ul class=\"dropdown-menu pull-right\" role=\"menu\">\n\t\t\t\t\t<li><a href=\"#\">Action</a>\n\t\t\t\t\t</li>\n\t\t\t\t\t<li><a href=\"#\">Another action</a>\n\t\t\t\t\t</li>\n\t\t\t\t\t<li><a href=\"#\">Something else here</a>\n\t\t\t\t\t</li>\n\t\t\t\t\t<li class=\"divider\"></li>\n\t\t\t\t\t<li><a href=\"#\">Separated link</a>\n\t\t\t\t\t</li>\n\t\t\t\t</ul>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\t<!-- /.panel-heading -->\n\t<div class=\"panel-body\">\n\t\t<div class=\"row\">\n\t\t\t<div class=\"col-lg-4\">\n\t\t\t\t<div class=\"table-responsive\">\n\t\t\t\t\t<table class=\"table table-bordered table-hover table-striped\">\n\t\t\t\t\t\t<thead>\n\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t<th>#</th>\n\t\t\t\t\t\t\t\t<th>Date</th>\n\t\t\t\t\t\t\t\t<th>Time</th>\n\t\t\t\t\t\t\t\t<th>Amount</th>\n\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t</thead>\n\t\t\t\t\t\t<tbody>\n\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t<td>3326</td>\n\t\t\t\t\t\t\t\t<td>10/21/2013</td>\n\t\t\t\t\t\t\t\t<td>3:29 PM</td>\n\t\t\t\t\t\t\t\t<td>$321.33</td>\n\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t<td>3325</td>\n\t\t\t\t\t\t\t\t<td>10/21/2013</td>\n\t\t\t\t\t\t\t\t<td>3:20 PM</td>\n\t\t\t\t\t\t\t\t<td>$234.34</td>\n\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t<td>3324</td>\n\t\t\t\t\t\t\t\t<td>10/21/2013</td>\n\t\t\t\t\t\t\t\t<td>3:03 PM</td>\n\t\t\t\t\t\t\t\t<td>$724.17</td>\n\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t<td>3323</td>\n\t\t\t\t\t\t\t\t<td>10/21/2013</td>\n\t\t\t\t\t\t\t\t<td>3:00 PM</td>\n\t\t\t\t\t\t\t\t<td>$23.71</td>\n\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t<td>3322</td>\n\t\t\t\t\t\t\t\t<td>10/21/2013</td>\n\t\t\t\t\t\t\t\t<td>2:49 PM</td>\n\t\t\t\t\t\t\t\t<td>$8345.23</td>\n\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t<td>3321</td>\n\t\t\t\t\t\t\t\t<td>10/21/2013</td>\n\t\t\t\t\t\t\t\t<td>2:23 PM</td>\n\t\t\t\t\t\t\t\t<td>$245.12</td>\n\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t<td>3320</td>\n\t\t\t\t\t\t\t\t<td>10/21/2013</td>\n\t\t\t\t\t\t\t\t<td>2:15 PM</td>\n\t\t\t\t\t\t\t\t<td>$5663.54</td>\n\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t<tr>\n\t\t\t\t\t\t\t\t<td>3319</td>\n\t\t\t\t\t\t\t\t<td>10/21/2013</td>\n\t\t\t\t\t\t\t\t<td>2:13 PM</td>\n\t\t\t\t\t\t\t\t<td>$943.45</td>\n\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t</tbody>\n\t\t\t\t\t</table>\n\t\t\t\t</div>\n\t\t\t\t<!-- /.table-responsive -->\n\t\t\t</div>\n\t\t\t<!-- /.col-lg-4 (nested) -->\n\t\t\t<div class=\"col-lg-8\">\n\t\t\t\t<div id=\"morris-bar-chart\" style=\"position: relative; -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\">\n\t\t\t\t\t<svg height=\"477\" version=\"1.1\" width=\"457\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n\t\t\t\t\tstyle=\"overflow: hidden; position: relative; left: -0.328125px;\">\n\t\t\t\t\t\t<desc style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\">Created with Raphaël 2.1.2</desc>\n\t\t\t\t\t\t<defs style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\"></defs>\n\t\t\t\t\t\t<text x=\"32.4375\" y=\"445\" text-anchor=\"end\" font-family=\"sans-serif\" font-size=\"12px\" stroke=\"none\" fill=\"#888888\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0); text-anchor: end; font-family: sans-serif; font-size: 12px; font-weight: normal;\"\n\t\t\t\t\t\tfont-weight=\"normal\">\n\t\t\t\t\t\t\t<tspan dy=\"4.25\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\">0</tspan>\n\t\t\t\t\t\t</text>\n\t\t\t\t\t\t<path fill=\"none\" stroke=\"#aaaaaa\" d=\"M44.9375,445H432\" stroke-width=\"0.5\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\"></path>\n\t\t\t\t\t\t<text x=\"32.4375\" y=\"340\" text-anchor=\"end\" font-family=\"sans-serif\" font-size=\"12px\" stroke=\"none\" fill=\"#888888\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0); text-anchor: end; font-family: sans-serif; font-size: 12px; font-weight: normal;\"\n\t\t\t\t\t\tfont-weight=\"normal\">\n\t\t\t\t\t\t\t<tspan dy=\"4.25\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\">25</tspan>\n\t\t\t\t\t\t</text>\n\t\t\t\t\t\t<path fill=\"none\" stroke=\"#aaaaaa\" d=\"M44.9375,340H432\" stroke-width=\"0.5\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\"></path>\n\t\t\t\t\t\t<text x=\"32.4375\" y=\"235\" text-anchor=\"end\" font-family=\"sans-serif\" font-size=\"12px\" stroke=\"none\" fill=\"#888888\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0); text-anchor: end; font-family: sans-serif; font-size: 12px; font-weight: normal;\"\n\t\t\t\t\t\tfont-weight=\"normal\">\n\t\t\t\t\t\t\t<tspan dy=\"4.25\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\">50</tspan>\n\t\t\t\t\t\t</text>\n\t\t\t\t\t\t<path fill=\"none\" stroke=\"#aaaaaa\" d=\"M44.9375,235H432\" stroke-width=\"0.5\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\"></path>\n\t\t\t\t\t\t<text x=\"32.4375\" y=\"130\" text-anchor=\"end\" font-family=\"sans-serif\" font-size=\"12px\" stroke=\"none\" fill=\"#888888\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0); text-anchor: end; font-family: sans-serif; font-size: 12px; font-weight: normal;\"\n\t\t\t\t\t\tfont-weight=\"normal\">\n\t\t\t\t\t\t\t<tspan dy=\"4.25\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\">75</tspan>\n\t\t\t\t\t\t</text>\n\t\t\t\t\t\t<path fill=\"none\" stroke=\"#aaaaaa\" d=\"M44.9375,130H432\" stroke-width=\"0.5\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\"></path>\n\t\t\t\t\t\t<text x=\"32.4375\" y=\"25\" text-anchor=\"end\" font-family=\"sans-serif\" font-size=\"12px\" stroke=\"none\" fill=\"#888888\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0); text-anchor: end; font-family: sans-serif; font-size: 12px; font-weight: normal;\"\n\t\t\t\t\t\tfont-weight=\"normal\">\n\t\t\t\t\t\t\t<tspan dy=\"4.25\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\">100</tspan>\n\t\t\t\t\t\t</text>\n\t\t\t\t\t\t<path fill=\"none\" stroke=\"#aaaaaa\" d=\"M44.9375,25H432\" stroke-width=\"0.5\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\"></path>\n\t\t\t\t\t\t<text x=\"404.35267857142856\" y=\"457.5\" text-anchor=\"middle\" font-family=\"sans-serif\" font-size=\"12px\" stroke=\"none\" fill=\"#888888\"\n\t\t\t\t\t\tstyle=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0); text-anchor: middle; font-family: sans-serif; font-size: 12px; font-weight: normal;\"\n\t\t\t\t\t\tfont-weight=\"normal\" transform=\"matrix(1,0,0,1,0,6)\">\n\t\t\t\t\t\t\t<tspan dy=\"4.25\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\">2012</tspan>\n\t\t\t\t\t\t</text>\n\t\t\t\t\t\t<text x=\"293.7633928571429\" y=\"457.5\" text-anchor=\"middle\" font-family=\"sans-serif\" font-size=\"12px\" stroke=\"none\" fill=\"#888888\"\n\t\t\t\t\t\tstyle=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0); text-anchor: middle; font-family: sans-serif; font-size: 12px; font-weight: normal;\"\n\t\t\t\t\t\tfont-weight=\"normal\" transform=\"matrix(1,0,0,1,0,6)\">\n\t\t\t\t\t\t\t<tspan dy=\"4.25\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\">2010</tspan>\n\t\t\t\t\t\t</text>\n\t\t\t\t\t\t<text x=\"183.17410714285714\" y=\"457.5\" text-anchor=\"middle\" font-family=\"sans-serif\" font-size=\"12px\" stroke=\"none\" fill=\"#888888\"\n\t\t\t\t\t\tstyle=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0); text-anchor: middle; font-family: sans-serif; font-size: 12px; font-weight: normal;\"\n\t\t\t\t\t\tfont-weight=\"normal\" transform=\"matrix(1,0,0,1,0,6)\">\n\t\t\t\t\t\t\t<tspan dy=\"4.25\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\">2008</tspan>\n\t\t\t\t\t\t</text>\n\t\t\t\t\t\t<text x=\"72.58482142857143\" y=\"457.5\" text-anchor=\"middle\" font-family=\"sans-serif\" font-size=\"12px\" stroke=\"none\" fill=\"#888888\"\n\t\t\t\t\t\tstyle=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0); text-anchor: middle; font-family: sans-serif; font-size: 12px; font-weight: normal;\"\n\t\t\t\t\t\tfont-weight=\"normal\" transform=\"matrix(1,0,0,1,0,6)\">\n\t\t\t\t\t\t\t<tspan dy=\"4.25\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\">2006</tspan>\n\t\t\t\t\t\t</text>\n\t\t\t\t\t\t<rect x=\"51.84933035714286\" y=\"25\" width=\"19.23549107142857\" height=\"420\" rx=\"0\" ry=\"0\" fill=\"#0b62a4\" stroke=\"none\" fill-opacity=\"1\"\n\t\t\t\t\t\tstyle=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0); fill-opacity: 1;\"></rect>\n\t\t\t\t\t\t<rect x=\"74.08482142857143\" y=\"67\" width=\"19.23549107142857\" height=\"378\" rx=\"0\" ry=\"0\" fill=\"#7a92a3\" stroke=\"none\" fill-opacity=\"1\"\n\t\t\t\t\t\tstyle=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0); fill-opacity: 1;\"></rect>\n\t\t\t\t\t\t<rect x=\"107.14397321428572\" y=\"130\" width=\"19.23549107142857\" height=\"315\" rx=\"0\" ry=\"0\" fill=\"#0b62a4\" stroke=\"none\" fill-opacity=\"1\"\n\t\t\t\t\t\tstyle=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0); fill-opacity: 1;\"></rect>\n\t\t\t\t\t\t<rect x=\"129.37946428571428\" y=\"172\" width=\"19.23549107142857\" height=\"273\" rx=\"0\" ry=\"0\" fill=\"#7a92a3\" stroke=\"none\" fill-opacity=\"1\"\n\t\t\t\t\t\tstyle=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0); fill-opacity: 1;\"></rect>\n\t\t\t\t\t\t<rect x=\"162.43861607142858\" y=\"235\" width=\"19.23549107142857\" height=\"210\" rx=\"0\" ry=\"0\" fill=\"#0b62a4\" stroke=\"none\" fill-opacity=\"1\"\n\t\t\t\t\t\tstyle=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0); fill-opacity: 1;\"></rect>\n\t\t\t\t\t\t<rect x=\"184.67410714285717\" y=\"277\" width=\"19.23549107142857\" height=\"168\" rx=\"0\" ry=\"0\" fill=\"#7a92a3\" stroke=\"none\" fill-opacity=\"1\"\n\t\t\t\t\t\tstyle=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0); fill-opacity: 1;\"></rect>\n\t\t\t\t\t\t<rect x=\"217.73325892857142\" y=\"130\" width=\"19.23549107142857\" height=\"315\" rx=\"0\" ry=\"0\" fill=\"#0b62a4\" stroke=\"none\" fill-opacity=\"1\"\n\t\t\t\t\t\tstyle=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0); fill-opacity: 1;\"></rect>\n\t\t\t\t\t\t<rect x=\"239.96875\" y=\"172\" width=\"19.23549107142857\" height=\"273\" rx=\"0\" ry=\"0\" fill=\"#7a92a3\" stroke=\"none\" fill-opacity=\"1\"\n\t\t\t\t\t\tstyle=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0); fill-opacity: 1;\"></rect>\n\t\t\t\t\t\t<rect x=\"273.0279017857143\" y=\"235\" width=\"19.23549107142857\" height=\"210\" rx=\"0\" ry=\"0\" fill=\"#0b62a4\" stroke=\"none\" fill-opacity=\"1\"\n\t\t\t\t\t\tstyle=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0); fill-opacity: 1;\"></rect>\n\t\t\t\t\t\t<rect x=\"295.26339285714283\" y=\"277\" width=\"19.23549107142857\" height=\"168\" rx=\"0\" ry=\"0\" fill=\"#7a92a3\" stroke=\"none\" fill-opacity=\"1\"\n\t\t\t\t\t\tstyle=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0); fill-opacity: 1;\"></rect>\n\t\t\t\t\t\t<rect x=\"328.3225446428571\" y=\"130\" width=\"19.23549107142857\" height=\"315\" rx=\"0\" ry=\"0\" fill=\"#0b62a4\" stroke=\"none\" fill-opacity=\"1\"\n\t\t\t\t\t\tstyle=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0); fill-opacity: 1;\"></rect>\n\t\t\t\t\t\t<rect x=\"350.55803571428567\" y=\"172\" width=\"19.23549107142857\" height=\"273\" rx=\"0\" ry=\"0\" fill=\"#7a92a3\" stroke=\"none\" fill-opacity=\"1\"\n\t\t\t\t\t\tstyle=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0); fill-opacity: 1;\"></rect>\n\t\t\t\t\t\t<rect x=\"383.61718749999994\" y=\"25\" width=\"19.23549107142857\" height=\"420\" rx=\"0\" ry=\"0\" fill=\"#0b62a4\" stroke=\"none\" fill-opacity=\"1\"\n\t\t\t\t\t\tstyle=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0); fill-opacity: 1;\"></rect>\n\t\t\t\t\t\t<rect x=\"405.8526785714285\" y=\"67\" width=\"19.23549107142857\" height=\"378\" rx=\"0\" ry=\"0\" fill=\"#7a92a3\" stroke=\"none\" fill-opacity=\"1\"\n\t\t\t\t\t\tstyle=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0); fill-opacity: 1;\"></rect>\n\t\t\t\t\t</svg>\n\t\t\t\t\t<div class=\"morris-hover morris-default-style\" style=\"left: 87.8795px; top: 203px; display: none;\">\n\t\t\t\t\t\t<div class=\"morris-hover-row-label\">2007</div>\n\t\t\t\t\t\t<div class=\"morris-hover-point\" style=\"color: #0b62a4\">\n\t\t\t\t\t\t\tSeries A: 75\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"morris-hover-point\" style=\"color: #7a92a3\">\n\t\t\t\t\t\t\tSeries B: 65\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<!-- /.col-lg-8 (nested) -->\n\t\t</div>\n\t\t<!-- /.row -->\n\t</div>\n\t<!-- /.panel-body -->\n</div>\n<!-- /.panel -->"

/***/ },
/* 143 */
/***/ function(module, exports) {

	module.exports = "<div class=\"chat-panel panel panel-default\" ng-init=\"chatCtrl.init()\">\n\t<div class=\"panel-heading\">\n\t\t<i class=\"fa fa-comments fa-fw\"></i> Chat\n\t\t<div class=\"btn-group pull-right\" sn-dropdown>\n\t\t\t<button type=\"button\" class=\"btn btn-default btn-xs dropdown-toggle\" data-toggle=\"dropdown\">\n\t\t\t\t<i class=\"fa fa-chevron-down\"></i>\n\t\t\t</button>\n\t\t\t<ul class=\"dropdown-menu slidedown\">\n\t\t\t\t<li>\n\t\t\t\t\t<a href=\"#\"><i class=\"fa fa-refresh fa-fw\"></i> Refresh</a>\n\t\t\t\t</li>\n\t\t\t\t<li>\n\t\t\t\t\t<a href=\"#\"><i class=\"fa fa-check-circle fa-fw\"></i> Available</a>\n\t\t\t\t</li>\n\t\t\t\t<li>\n\t\t\t\t\t<a href=\"#\"><i class=\"fa fa-times fa-fw\"></i> Busy</a>\n\t\t\t\t</li>\n\t\t\t\t<li>\n\t\t\t\t\t<a href=\"#\"><i class=\"fa fa-clock-o fa-fw\"></i> Away</a>\n\t\t\t\t</li>\n\t\t\t\t<li class=\"divider\"></li>\n\t\t\t\t<li>\n\t\t\t\t\t<a href=\"#\"><i class=\"fa fa-sign-out fa-fw\"></i> Sign Out</a>\n\t\t\t\t</li>\n\t\t\t</ul>\n\t\t</div>\n\t</div>\n\t<!-- /.panel-heading -->\n\t<div class=\"panel-body\">\n\t\t<ul class=\"chat\">\n\t\t\t<li class=\"clearfix\" ng-repeat=\"message in chatCtrl.chatList\" ng-class-even=\"'left'\" ng-class-odd=\"'right'\">\n\t\t\t\t<span class=\"chat-img\" ng-class-even=\"'pull-left'\" ng-class-odd=\"'pull-right'\">\n\t\t\t\t\t<img src=\"http://placehold.it/50/55C1E7/fff\" alt=\"User Avatar\" class=\"img-circle\">\n\t\t\t\t</span>\n\t\t\t\t<div class=\"chat-body clearfix\">\n\t\t\t\t\t<div class=\"header\">\n\t\t\t\t\t\t<strong class=\"primary-font\">{{message.from}}</strong>\n\t\t\t\t\t\t<small class=\"pull-right text-muted\">\n\t\t\t\t\t\t\t<i class=\"fa fa-clock-o fa-fw\"></i> {{message.date | fromNow}}\n\t\t\t\t\t\t</small>\n\t\t\t\t\t</div>\n\t\t\t\t\t<p>{{message.content}}</p>\n\t\t\t\t</div>\n\t\t\t</li>\n\t\t</ul>\n\t</div>\n\t<!-- /.panel-body -->\n\t<div class=\"panel-footer\">\n\t\t<div class=\"input-group\">\n\t\t\t<input type=\"text\" class=\"form-control input-sm\" placeholder=\"Type your message here...\" ng-model=\"chatCtrl.newMessage\">\n\t\t\t<span class=\"input-group-btn\">\n\t\t\t\t<button class=\"btn btn-warning btn-sm\" ng-click=\"chatCtrl.sendMessage()\">Send</button>\n\t\t\t</span>\n\t\t</div>\n\t</div>\n\t<!-- /.panel-footer -->\n</div>"

/***/ },
/* 144 */
/***/ function(module, exports) {

	module.exports = "<div class=\"row\" ng-init=\"dashboardCtrl.init()\">\n    <div class=\"col-lg-3 col-md-6\" ng-repeat=\"item in dashboardCtrl.aggregationItems\">\n        <sn-aggregation-item-panel data=\"item\"></sn-aggregation-item-panel>\n    </div>\n</div>\n\n<div class=\"row\">\n    <div class=\"col-lg-8\">\n        <sn-area-chart-panel></sn-area-chart-panel>\n        <sn-bar-chart-panel></sn-bar-chart-panel>\n        <sn-timeline-panel></sn-timeline-panel>\n    </div>\n    <div class=\"col-lg-4\">\n        <sn-notification-panel></sn-notification-panel>\n        <sn-donut-panel></sn-donut-panel>\n        <sn-chat-panel></sn-chat-panel>\n    </div>\n</div>"

/***/ },
/* 145 */
/***/ function(module, exports) {

	module.exports = "<div class=\"panel panel-default\">\n\t<div class=\"panel-heading\">\n\t\t<i class=\"fa fa-bar-chart-o fa-fw\"></i> Donut Chart Example\n\t</div>\n\t<div class=\"panel-body\">\n\t\t<div id=\"morris-donut-chart\">\n\t\t\t<svg height=\"477\" version=\"1.1\" width=\"319\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"\n\t\t\tstyle=\"overflow: hidden; position: relative;\">\n\t\t\t\t<desc style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\">Created with Raphaël 2.1.2</desc>\n\t\t\t\t<defs style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\"></defs>\n\t\t\t\t<path fill=\"none\" stroke=\"#0b62a4\" d=\"M159.5,340.6666666666667A99.66666666666667,99.66666666666667,0,0,0,253.6681290975732,273.64671356671647\"\n\t\t\t\tstroke-width=\"2\" opacity=\"0\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0); opacity: 0;\"></path>\n\t\t\t\t<path fill=\"#0b62a4\" stroke=\"#ffffff\" d=\"M159.5,343.6666666666667A102.66666666666667,102.66666666666667,0,0,0,256.50262127776773,274.62939056370794L296.02804001270226,288.332275355089A144.5,144.5,0,0,1,159.5,385.5Z\"\n\t\t\t\tstroke-width=\"3\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\"></path>\n\t\t\t\t<path fill=\"none\" stroke=\"#3980b5\" d=\"M253.6681290975732,273.64671356671647A99.66666666666667,99.66666666666667,0,0,0,70.09933662699727,196.9436062198517\"\n\t\t\t\tstroke-width=\"2\" opacity=\"1\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0); opacity: 1;\"></path>\n\t\t\t\t<path fill=\"#3980b5\" stroke=\"#ffffff\" d=\"M256.50262127776773,274.62939056370794A102.66666666666667,102.66666666666667,0,0,0,67.40834675958247,195.61749403248933L25.3990049404959,174.9154093297775A149.5,149.5,0,0,1,300.75219364635984,289.97007035007476Z\"\n\t\t\t\tstroke-width=\"3\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\"></path>\n\t\t\t\t<path fill=\"none\" stroke=\"#679dc6\" d=\"M70.09933662699727,196.9436062198517A99.66666666666667,99.66666666666667,0,0,0,159.4686887937342,340.66666174831386\"\n\t\t\t\tstroke-width=\"2\" opacity=\"0\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0); opacity: 0;\"></path>\n\t\t\t\t<path fill=\"#679dc6\" stroke=\"#ffffff\" d=\"M67.40834675958247,195.61749403248933A102.66666666666667,102.66666666666667,0,0,0,159.4677463159536,343.6666616002698L159.45460398690224,385.49999286921087A144.5,144.5,0,0,1,29.88398805285391,177.1255963087147Z\"\n\t\t\t\tstroke-width=\"3\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\"></path>\n\t\t\t\t<text x=\"159.5\" y=\"231\" text-anchor=\"middle\" font-family=\"&quot;Arial&quot;\" font-size=\"15px\" stroke=\"none\" fill=\"#000000\"\n\t\t\t\tstyle=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0); text-anchor: middle; font-family: Arial; font-size: 15px; font-weight: 800;\"\n\t\t\t\tfont-weight=\"800\" transform=\"matrix(1.7934,0,0,1.7934,-126.5412,-189.8304)\" stroke-width=\"0.5575877926421404\">\n\t\t\t\t\t<tspan dy=\"5.25\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\">In-Store Sales</tspan>\n\t\t\t\t</text>\n\t\t\t\t<text x=\"159.5\" y=\"251\" text-anchor=\"middle\" font-family=\"&quot;Arial&quot;\" font-size=\"14px\" stroke=\"none\" fill=\"#000000\"\n\t\t\t\tstyle=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0); text-anchor: middle; font-family: Arial; font-size: 14px;\" transform=\"matrix(2.1434,0,0,2.1434,-182.3495,-278.1246)\"\n\t\t\t\tstroke-width=\"0.4665551839464883\">\n\t\t\t\t\t<tspan dy=\"4.75\" style=\"-webkit-tap-highlight-color: rgba(0, 0, 0, 0);\">30</tspan>\n\t\t\t\t</text>\n\t\t\t</svg>\n\t\t</div>\n\t\t<a href=\"#\" class=\"btn btn-default btn-block\">View Details</a>\n\t</div>\n\t<!-- /.panel-body -->\n</div>\n<!-- /.panel -->"

/***/ },
/* 146 */
/***/ function(module, exports) {

	module.exports = "<div class=\"panel panel-default\" ng-init=\"notificationCtrl.init()\">\n\t<div class=\"panel-heading\">\n\t\t<i class=\"fa fa-bell fa-fw\"></i> Notifications Panel\n\t</div>\n\t<!-- /.panel-heading -->\n\t<div class=\"panel-body\">\n\t\t<div class=\"list-group\">\n\t\t\t<a href=\"#\" ng-repeat=\"notification in notificationCtrl.notifications\" class=\"list-group-item\">\n\t\t\t\t<i class=\"fa fa-fw\" ng-class=\"'fa-' + notification.type\"></i> {{notification.content}}\n\t\t\t\t<span class=\"pull-right text-muted small\">\n\t\t\t\t\t<em>{{notification.date | fromNow}}</em>\n                </span>\n\t\t\t</a>\n\t\t</div>\n\t\t<!-- /.list-group -->\n\t\t<a href=\"#\" class=\"btn btn-default btn-block\">View All Alerts</a>\n\t</div>\n\t<!-- /.panel-body -->\n</div>"

/***/ },
/* 147 */
/***/ function(module, exports) {

	module.exports = "<div class=\"panel panel-default\" ng-init=\"timelineCtrl.init()\">\n\t<div class=\"panel-heading\">\n\t\t<i class=\"fa fa-clock-o fa-fw\"></i> Responsive Timeline\n\t</div>\n\t<!-- /.panel-heading -->\n\t<div class=\"panel-body\">\n\t\t<ul class=\"timeline\">\n\t\t\t<li ng-repeat=\"activity in timelineCtrl.timeline\" ng-class-odd=\"'timeline-inverted'\">\n\t\t\t\t<div class=\"timeline-badge primary\"><i class=\"fa fa-user\"></i>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"timeline-panel\">\n\t\t\t\t\t<div class=\"timeline-heading\">\n\t\t\t\t\t\t<h4 class=\"timeline-title\">{{activity.title}}</h4>\n\t\t\t\t\t\t<p><small class=\"text-muted\"><i class=\"fa fa-clock-o\"></i> {{activity.date | fromNow}} via Twitter</small>\n\t\t\t\t\t\t</p>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"timeline-body\">\n\t\t\t\t\t\t<p>{{activity.content}}</p>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</li>\n\t\t</ul>\n\t</div>\n\t<!-- /.panel-body -->\n</div>"

/***/ },
/* 148 */
/***/ function(module, exports) {

	module.exports = "<div class=\"panel panel-default\" ng-init=\"choiceCtrl.init()\">\n\t<div class=\"panel-heading\">\n\t\tMake Choice\n\t</div>\n\t<div class=\"panel-body\">\n\t\t<h3>Follow your heart: </h3>\n\t\t\n\t\t<ul class=\"list-group\">\n\t\t\t<li class=\"list-group-item\"\n\t\t\t\tng-repeat=\"choice in choiceCtrl.flow.context.choices\"\n\t\t\t\tng-click=\"choiceCtrl.flow.context.currentChoice=choice\">\n\t\t\t\t<a href=\"javascript:void(0)\">choice.label</a>\n\t\t\t</li>\n\t\t</ul>\n\t</div>\n\t<div class=\"panel-footer\">\n\t\t<button class=\"btn btn-sm btn-primary\" ng-click=\"choiceCtrl.next()\">Next</button>\n\t</div>\n</div>"

/***/ },
/* 149 */
/***/ function(module, exports) {

	module.exports = "<div class=\"panel panel-default\" ng-init=\"euclidCtrl.init()\">\n\t<div class=\"panel-heading\">\n\t\tEuclid\n\t</div>\n\t<div class=\"panel-body\">\n\t\t<form class=\"form-horizontal\">\n\t\t\t<div class=\"form-group\">\n\t\t\t\t<label class=\"col-sm-2 control-label\">First Number</label>\n\t\t\t\t<div class=\"col-sm-10\">\n\t\t\t\t\t<input type=\"number\" class=\"form-control\" placeholder=\"First Number\" ng-model=\"euclidCtrl.flow.context.a\">\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"form-group\">\n\t\t\t\t<label class=\"col-sm-2 control-label\">Second Number</label>\n\t\t\t\t<div class=\"col-sm-10\">\n\t\t\t\t\t<input type=\"number\" class=\"form-control\" placeholder=\"Second Number\" ng-model=\"euclidCtrl.flow.context.b\">\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"form-group\">\n\t\t\t\t<label class=\"col-sm-2 control-label\">Result</label>\n\t\t\t\t<p class=\"col-sm-10 form-control-static\">\n\t\t\t\t\t{{euclidCtrl.flow.context.result}}\n\t\t\t\t</p>\n\t\t\t</div>\n\t\t</form>\n\t</div>\n\t<div class=\"panel-footer\">\n\t\t<button class=\"btn btn-sm btn-primary\" ng-click=\"euclidCtrl.next()\">Next</button>\n\t</div>\n</div>"

/***/ },
/* 150 */
/***/ function(module, exports) {

	module.exports = "<div ng-init=\"employeeListCtrl.init()\">\n\t<h1 class=\"page-header\">Employees <small>All Employees</small></h1>\n\n\t<div class=\"row\">\n\t\t<form class=\"navbar-form navbar-left\" role=\"search\">\n\t\t\t<div class=\"form-group\">\n\t\t\t\t<button ng-click=\"employeeListCtrl.newEmployee()\" class=\"btn btn-primary\">New</button>\n\t\t\t</div>\n\t\t\t<div class=\"form-group\">\n\t\t\t\t<button ng-click=\"employeeListCtrl.deleteEmployee()\" ng-disabled=\"!employeeListCtrl.selectedEmployee\" class=\"btn btn-danger\">Delete</button>\n\t\t\t</div>\n\t\t\t<div class=\"form-group\">\n\t\t\t\t<input type=\"text\" class=\"form-control\" placeholder=\"Search\">\n\t\t\t\t<button type=\"submit\" class=\"btn btn-default\">\n\t\t\t\t\t<i class=\"glyphicon glyphicon-search\"></i>\n\t\t\t\t</button>\n\t\t\t</div>\n\t\t</form>\n\t</div>\n\t<table class=\"table table-bordered\">\n\t\t<thead>\n\t\t\t<tr>\n\t\t\t\t<th>Name</th>\n\t\t\t\t<th>Age</th>\n\t\t\t\t<th>Gender</th>\n\t\t\t</tr>\n\t\t</thead>\n\t\t<tbody>\n\t\t\t<tr ng-repeat=\"employee in employeeListCtrl.employeeList\"\n\t\t\tng-class=\"{'active':employee==employeeListCtrl.selectedEmployee}\"\n\t\t\tng-click=\"employeeListCtrl.selectedEmployee=employee\">\n\t\t\t\t<td>{{employee.name}}</td>\n\t\t\t\t<td>{{employee.age}}</td>\n\t\t\t\t<td>{{employee.gender | gender}}</td>\n\t\t\t</tr>\n\t\t</tbody>\n\t</table>\n\n\t<!--sn-datagrid type=\"'sortable'\" grid-cols=\"employeeListCtrl.employeeCols\" grid-data=\"employeeListCtrl.employeeList\"></sn-datagrid-->\n\n\t<sn-pager count=\"employeeListCtrl.total\" current-page=\"employeeListCtrl.currentPage\"></sn-pager>\n</div>"

/***/ },
/* 151 */
/***/ function(module, exports) {

	module.exports = "<div class=\"modal fade in\" ng-controller=\"NewEmployeeDialogController as dialogCtrl\" ng-init=\"dialogCtrl.dialog=dialog\">\n\t<div class=\"modal-dialog\">\n\t\t<div class=\"modal-content\">\n\t\t\t<div class=\"modal-header\">\n\t\t\t\t<button type=\"button\" class=\"close\" data-dismiss=\"modal\" ng-click=\"dialog.close()\"><span\n\t\t\t\t\t\taria-hidden=\"true\">&times;</span><span\n\t\t\t\t\t\tclass=\"sr-only\">Close</span></button>\n\t\t\t\t<h4 class=\"modal-title\">New Employee</h4>\n\t\t\t</div>\n\t\t\t<div class=\"modal-body\">\n\t\t\t\t<form class=\"form-horizontal\" role=\"form\">\n\t\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t\t<label class=\"col-sm-2 control-label\">Name</label>\n\n\t\t\t\t\t\t<div class=\"col-sm-10\">\n\t\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" placeholder=\"Name\" ng-model=\"dialogCtrl.name\"/>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t\t<label class=\"col-sm-2 control-label\">Age</label>\n\n\t\t\t\t\t\t<div class=\"col-sm-10\">\n\t\t\t\t\t\t\t<input type=\"number\" class=\"form-control\" placeholder=\"Age\" ng-model=\"dialogCtrl.age\"/>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t\t<label class=\"col-sm-2 control-label\">Gender</label>\n\n\t\t\t\t\t\t<div class=\"col-sm-10\">\n\t\t\t\t\t\t\t<select class=\"form-control\" ng-model=\"dialogCtrl.gender\">\n\t\t\t\t\t\t\t\t<option value=\"0\">Female</option>\n\t\t\t\t\t\t\t\t<option value=\"1\">Male</option>\n\t\t\t\t\t\t\t</select>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</form>\n\t\t\t</div>\n\t\t\t<div class=\"modal-footer\">\n\t\t\t\t<button type=\"button\" class=\"btn btn-primary\" ng-click=\"dialogCtrl.ok()\">OK</button>\n\t\t\t\t<button type=\"button\" class=\"btn btn-primary\" ng-click=\"dialog.cancel()\">Cancel</button>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>"

/***/ },
/* 152 */
/***/ function(module, exports) {

	module.exports = "<div class=\"panel panel-default\" ng-init=\"entityListCtrl.init()\">\n\t<div class=\"panel-heading\">\n\t\t<span>Entities</span>\n\t</div>\n\t<div class=\"panel-body\">\n\t\t<ul class=\"list-group\">\n\t\t\t<li ng-repeat=\"entity in entityListCtrl.entityList\"\n\t\t\t\tng-class=\"{'active':entity==entityListCtrl.selectedEntity}\"\n\t\t\t\tng-click=\"entityListCtrl.selectEntity(entity)\"\n\t\t\t\tclass=\"list-group-item\">\n\t\t\t\t<span>{{entity.name}}</span>\n\t\t\t</li>\n\t\t</ul>\n\t</div>\n\t<div class=\"panel-footer\">\n\t\t<div class=\"row\">\n\t\t\t<form class=\"navbar-form navbar-left\" role=\"search\">\n\t\t\t\t<!--div class=\"form-group\">\n\t\t\t\t\t<input type=\"text\" class=\"form-control\" placeholder=\"Search\">\n\t\t\t\t\t<button type=\"submit\" class=\"btn btn-default\">\n\t\t\t\t\t\t<i class=\"glyphicon glyphicon-search\"></i>\n\t\t\t\t\t</button>\n\t\t\t\t</div-->\n\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t<button ng-click=\"entityListCtrl.newEntity()\"\n\t\t\t\t\t\tclass=\"btn btn-sm btn-primary\">New</button>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t<button ng-click=\"entityListCtrl.deleteEntity()\"\n\t\t\t\t\t\tng-disabled=\"!entityListCtrl.selectedEntity\"\n\t\t\t\t\t\tclass=\"btn btn-sm btn-danger\">Delete</button>\n\t\t\t\t</div>\n\t\t\t</form>\n\t\t</div>\n\t</div>\n</div>"

/***/ },
/* 153 */
/***/ function(module, exports) {

	module.exports = "<div class=\"row\" ng-init=\"entityManageCtrl.init()\">\n\t<div class=\"col-md-12\">\n\t\t<h1 class=\"page-header\">Entity Management <small>Dynamic Entity Configuration</small></h1>\n\t</div>\n\n\t<div class=\"col-md-3\">\n\t\t<sn-entity-list selected-entity=\"entityManageCtrl.selectedEntity\"></sn-entity-list>\n\t</div>\n\t<div class=\"col-md-9\">\n\t\t<sn-entity-property-list selected-entity=\"entityManageCtrl.selectedEntity\"></sn-entity-property-list>\n\t\t<sn-entity-rule-list selected-entity=\"entityManageCtrl.selectedEntity\"></sn-entity-rule-list>\n\t</div>\n</div>"

/***/ },
/* 154 */
/***/ function(module, exports) {

	module.exports = "<div class=\"panel panel-default\" ng-init=\"entityPropertyListCtrl.init()\">\n\t<div class=\"panel-heading\">\n\t\t<span>Entity Properties</span>\n\t</div>\n\t<div class=\"panel-body\">\n\t\t<table class=\"table table-bordered\">\n\t\t\t<thead>\n\t\t\t\t<tr>\n\t\t\t\t\t<th>Name</th>\n\t\t\t\t\t<th>Type</th>\n\t\t\t\t\t<th>Required</th>\n\t\t\t\t\t<th>Is Primary Key</th>\n\t\t\t\t</tr>\n\t\t\t</thead>\n\t\t\t<tbody>\n\t\t\t\t<tr ng-repeat=\"property in entityPropertyListCtrl.propertyList\"\n\t\t\t\tng-class=\"{'active':property==entityPropertyListCtrl.selectedProperty}\"\n\t\t\t\tng-click=\"entityPropertyListCtrl.selectedProperty=property\">\n\t\t\t\t\t<td>{{property.name}}</td>\n\t\t\t\t\t<td>{{property.type}}</td>\n\t\t\t\t\t<td>{{property.required}}</td>\n\t\t\t\t\t<td>{{property.isPrimaryKey}}</td>\n\t\t\t\t</tr>\n\t\t\t</tbody>\n\t\t</table>\n\t</div>\n\t<div class=\"panel-footer\">\n\t\t<div class=\"row\">\n\t\t\t<form class=\"navbar-form navbar-left\" role=\"operation\">\n\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t<button ng-click=\"entityPropertyListCtrl.newProperty()\"\n\t\t\t\t\t\tclass=\"btn btn-sm btn-primary\">New</button>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t<button ng-click=\"entityPropertyListCtrl.deleteProperty()\"\n\t\t\t\t\t\tng-disabled=\"!entityPropertyListCtrl.selectedProperty\"\n\t\t\t\t\t\tclass=\"btn btn-sm btn-danger\">Delete</button>\n\t\t\t\t</div>\n\t\t\t</form>\n\t\t</div>\n\t</div>\n</div>"

/***/ },
/* 155 */
/***/ function(module, exports) {

	module.exports = "<div class=\"panel panel-default\" ng-init=\"entityRuleListCtrl.init()\">\n\t<div class=\"panel-heading\">\n\t\t<span>Entity Rules</span>\n\t</div>\n\t<div class=\"panel-body\">\n\t\t<table class=\"table table-bordered\">\n\t\t\t<thead>\n\t\t\t\t<tr>\n\t\t\t\t\t<th>Name</th>\n\t\t\t\t\t<th>Return Type</th>\n\t\t\t\t\t<th>Params</th>\n\t\t\t\t\t<th>Body</th>\n\t\t\t\t\t<th>Asynchronous</th>\n\t\t\t\t</tr>\n\t\t\t</thead>\n\t\t\t<tbody>\n\t\t\t\t<tr ng-repeat=\"rule in entityRuleListCtrl.ruleList\"\n\t\t\t\tng-class=\"{'active':rule==entityRuleListCtrl.selectedRule}\"\n\t\t\t\tng-click=\"entityRuleListCtrl.selectedRule=rule\">\n\t\t\t\t\t<td>{{rule.name}}</td>\n\t\t\t\t\t<td>{{rule.returnType}}</td>\n\t\t\t\t\t<td>\n\t\t\t\t\t\t<ul class=\"list-group\">\n\t\t\t\t\t\t\t<li class=\"list-group-item\" ng-repeat=\"param in rule.params\">\n\t\t\t\t\t\t\t\t<span class=\"badge\">{{param.type}}</span>\n\t\t\t\t\t\t\t\t{{param.name}}\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t</ul>\n\t\t\t\t\t</td>\n\t\t\t\t\t<td>{{rule.body}}</td>\n\t\t\t\t\t<td>{{rule.async}}</td>\n\t\t\t\t</tr>\n\t\t\t</tbody>\n\t\t</table>\n\t</div>\n\t<div class=\"panel-footer\">\n\t\t<div class=\"row\">\n\t\t\t<form class=\"navbar-form navbar-left\" role=\"operation\">\n\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t<button ng-click=\"entityRuleListCtrl.newRule()\"\n\t\t\t\t\t\tclass=\"btn btn-sm btn-primary\">New</button>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t<button ng-click=\"entityRuleListCtrl.deleteRule()\"\n\t\t\t\t\t\tng-disabled=\"!entityRuleListCtrl.selectedRule\"\n\t\t\t\t\t\tclass=\"btn btn-sm btn-danger\">Delete</button>\n\t\t\t\t</div>\n\t\t\t</form>\n\t\t</div>\n\t</div>\n</div>"

/***/ },
/* 156 */
/***/ function(module, exports) {

	module.exports = "<div ng-init=\"flowCtrl.init()\">\n\t<div>\n\t\ta: {{flowCtrl.flow.context.a}}\n\t</div>\n\t<div>\n\t\tb: {{flowCtrl.flow.context.b}}\n\t</div>\n\t<button class=\"btn btn-default\" ng-click=\"flowCtrl.start()\">Start</button>\n\t<button class=\"btn btn-default\" ng-click=\"flowCtrl.step()\">Step</button>\n</div>"

/***/ },
/* 157 */
/***/ function(module, exports) {

	module.exports = "<li class=\"dropdown\" sn-dropdown ng-init=\"alertListCtrl.init()\">\n\t<a class=\"dropdown-toggle\" data-toggle=\"dropdown\" href=\"#\">\n\t\t<i class=\"fa fa-bell fa-fw\"></i> <i class=\"fa fa-caret-down\"></i>\n\t</a>\n\t<!-- /.dropdown -->\n\t<ul class=\"dropdown-menu dropdown-alerts\">\n\t\t<li ng-repeat-start=\"alert in alertListCtrl.alertList\">\n\t\t\t<a href=\"#\">\n\t\t\t\t<div>\n\t\t\t\t\t<i class=\"fa fa-fw\" ng-class=\"alertListCtrl.alertClass(alert.type)\"></i> {{alert.content}}\n\t\t\t\t\t<span class=\"pull-right text-muted small\">{{alert.date | fromNow}}</span>\n\t\t\t\t</div>\n\t\t\t</a>\n\t\t</li>\n\t\t<li ng-repeat-end class=\"divider\"></li>\n\t\t<li>\n\t\t\t<a class=\"text-center\" href=\"#\">\n\t\t\t\t<strong>See All Alerts</strong>\n\t\t\t\t<i class=\"fa fa-angle-right\"></i>\n\t\t\t</a>\n\t\t</li>\n\t</ul>\n\t<!-- /.dropdown-alerts -->\n</li>"

/***/ },
/* 158 */
/***/ function(module, exports) {

	module.exports = "<li class=\"dropdown\" sn-dropdown ng-init=\"messageListCtrl.init()\">\n\t<a class=\"dropdown-toggle\" data-toggle=\"dropdown\" href=\"#\" aria-expanded=\"false\">\n\t\t<i class=\"fa fa-envelope fa-fw\"></i> <i class=\"fa fa-caret-down\"></i>\n\t</a>\n\t<!-- /.dropdown -->\n\t<ul class=\"dropdown-menu dropdown-messages\">\n\t\t<li ng-repeat-start=\"message in messageListCtrl.messageList\">\n\t\t\t<a href=\"#\">\n\t\t\t\t<div>\n\t\t\t\t\t<strong>{{message.title}}</strong>\n\t\t\t\t\t<span class=\"pull-right text-muted\">\n\t\t\t\t\t\t<em>{{message.date | fromNow}}</em>\n\t\t\t\t\t</span>\n\t\t\t\t</div>\n\t\t\t\t<div>{{message.content}}</div>\n\t\t\t</a>\n\t\t</li>\n\t\t<li ng-repeat-end class=\"divider\"></li>\n\t\t<li>\n\t\t\t<a class=\"text-center\" ui-sref=\"Messages\">\n\t\t\t\t<strong>Read All Messages</strong>\n\t\t\t\t<i class=\"fa fa-angle-right\"></i>\n\t\t\t</a>\n\t\t</li>\n\t</ul>\n\t<!-- /.dropdown-messages -->\n</li>"

/***/ },
/* 159 */
/***/ function(module, exports) {

	module.exports = "<div>\n\t<h1 class=\"page-header\">Messages <small>messages received</small></h1>\n\n\t<div class=\"panel panel-default\" ng-init=\"messageListCtrl.init()\">\n\t\t<div class=\"panel-heading\">\n\t\t\tAll Messages\n\t\t</div>\n\t\t<!-- /.panel-heading -->\n\t\t<div class=\"panel-body\">\n\t\t\t<div class=\"row\">\n\t\t\t\t<form class=\"navbar-form navbar-left\" role=\"search\">\n\t\t\t\t\t<div class=\"form-group\">\n\t\t\t\t\t\t<input type=\"text\" class=\"form-control\" placeholder=\"Search\">\n\t\t\t\t\t</div>\n\t\t\t\t\t<button type=\"submit\" class=\"btn btn-default\">\n\t\t\t\t\t\t<i class=\"glyphicon glyphicon-search\"></i>\n\t\t\t\t\t</button>\n\t\t\t\t</form>\n\t\t\t</div>\n\n\t\t\t<sn-datagrid type=\"'sortable'\" grid-cols=\"messageListCtrl.messageCols\" grid-data=\"messageListCtrl.messageList\"></sn-datagrid>\n\n\t\t\t<sn-pager count=\"177\"></sn-pager>\n\t\t</div>\n\t\t<!-- /.panel-body -->\n\t</div>\n\t<!-- /.panel -->\n</div>"

/***/ },
/* 160 */
/***/ function(module, exports) {

	module.exports = "<div class=\"navbar-default sidebar\" role=\"navigation\" ng-init=\"sideNavCtrl.init()\">\n\t<div class=\"sidebar-nav navbar-collapse\">\n\t\t<ul class=\"nav in\">\n\t\t\t<li class=\"sidebar-search\">\n\t\t\t\t<div class=\"input-group custom-search-form\">\n\t\t\t\t\t<input type=\"text\" class=\"form-control\" placeholder=\"Search...\">\n\t\t\t\t\t<span class=\"input-group-btn\">\n\t\t\t\t\t\t<button class=\"btn btn-default\" type=\"button\">\n\t\t\t\t\t\t\t<i class=\"fa fa-search\"></i>\n\t\t\t\t\t\t</button>\n\t\t\t\t\t</span>\n\t\t\t\t</div>\n\t\t\t</li>\n\n\t\t\t<li ng-repeat=\"menu in sideNavCtrl.menuTree\">\n\t\t\t\t<a ui-sref=\"{{menu.state || 'default'}}\" ng-click=\"sideNavCtrl.menuClick(menu, $event)\">\n\t\t\t\t\t<i class=\"fa fa-fw\" ng-class=\"menu.icon\"></i>{{menu.name}}\n\t\t\t\t\t<i ng-if=\"menu.children\" class=\"fa arrow\"></i>\n\t\t\t\t</a>\n\t\t\t\t<ul ng-if=\"menu.children\" class=\"nav nav-second-level\" ng-class=\"{'collapse':!menu.$expanded}\">\n\t\t\t\t\t<li ng-repeat=\"child in menu.children\">\n\t\t\t\t\t\t<a ui-sref=\"{{child.state || 'default'}}\" ng-click=\"sideNavCtrl.menuClick(child, $event)\">\n\t\t\t\t\t\t\t{{child.name}}\n\t\t\t\t\t\t\t<i ng-if=\"child.children\" class=\"fa arrow\"></i>\n\t\t\t\t\t\t</a>\n\t\t\t\t\t\t<ul ng-if=\"child.children\" class=\"nav nav-third-level\"\n\t\t\t\t\t\t\tng-class=\"{'collapse':!child.$expanded}\">\n\t\t\t\t\t\t\t<li ng-repeat=\"grandson in child.children\">\n\t\t\t\t\t\t\t\t<a ui-sref=\"{{grandson.state || 'default'}}\">{{grandson.name}}</a>\n\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t</ul>\n\t\t\t\t\t</li>\n\t\t\t\t</ul>\n\t\t\t</li>\n\t\t</ul>\n\t</div>\n</div>"

/***/ },
/* 161 */
/***/ function(module, exports) {

	module.exports = "<li class=\"dropdown\" sn-dropdown ng-init=\"taskListCtrl.init()\">\n\t<a class=\"dropdown-toggle\" data-toggle=\"dropdown\" href=\"#\">\n\t\t<i class=\"fa fa-tasks fa-fw\"></i> <i class=\"fa fa-caret-down\"></i>\n\t</a>\n\t<!-- /.dropdown -->\n\t<ul class=\"dropdown-menu dropdown-tasks\">\n\t\t<li ng-repeat-start=\"task in taskListCtrl.taskList\">\n\t\t\t<a href=\"#\">\n\t\t\t\t<div>\n\t\t\t\t\t<p>\n\t\t\t\t\t\t<strong>{{task.name}}</strong>\n\t\t\t\t\t\t<span class=\"pull-right text-muted\">{{task.percentage}}% Complete</span>\n\t\t\t\t\t</p>\n\t\t\t\t\t<div class=\"progress progress-striped active\">\n\t\t\t\t\t\t<div class=\"progress-bar\" ng-class=\"taskListCtrl.taskClass($index)\" role=\"progressbar\" ng-aria-valuenow=\"{{task.percentage}}\" aria-valuemin=\"0\" aria-valuemax=\"100\"\n\t\t\t\t\t\tng-style=\"{width: task.percentage + '%'}\">\n\t\t\t\t\t\t\t<span class=\"sr-only\">{{task.percentage}}% Complete (success)</span>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</a>\n\t\t</li>\n\t\t<li ng-repeat-end class=\"divider\"></li>\n\t\t<li>\n\t\t\t<a class=\"text-center\" href=\"#\">\n\t\t\t\t<strong>See All Tasks</strong>\n\t\t\t\t<i class=\"fa fa-angle-right\"></i>\n\t\t\t</a>\n\t\t</li>\n\t</ul>\n\t<!-- /.dropdown-tasks -->\n</li>"

/***/ },
/* 162 */
/***/ function(module, exports) {

	module.exports = "<nav class=\"navbar navbar-default navbar-fixed-top\" role=\"navigation\">\n\t<div class=\"navbar-header\">\n\t\t<button type=\"button\" class=\"navbar-toggle\">\n\t\t\t<span class=\"sr-only\">Toggle navigation</span>\n\t\t\t<span class=\"icon-bar\"></span>\n\t\t\t<span class=\"icon-bar\"></span>\n\t\t\t<span class=\"icon-bar\"></span>\n\t\t</button>\n\t\t<a class=\"navbar-brand\" href=\"index.html\">Ng Admin</a>\n\t</div>\n\t<!-- /.navbar-header -->\n\n\t<ul class=\"nav navbar-top-links navbar-right\">\n\t\t<sn-message-dropdown></sn-message-dropdown>\n\t\t<sn-task-dropdown></sn-task-dropdown>\n\t\t<sn-alert-dropdown></sn-alert-dropdown>\n\n\t\t<!-- /.dropdown -->\n\t\t<li class=\"dropdown\" sn-dropdown>\n\t\t\t<a class=\"dropdown-toggle\" data-toggle=\"dropdown\" href=\"#\">\n\t\t\t\t<i class=\"fa fa-user fa-fw\"></i> <i class=\"fa fa-caret-down\"></i>\n\t\t\t</a>\n\t\t\t<ul class=\"dropdown-menu dropdown-user\">\n\t\t\t\t<li><a href=\"#\"><i class=\"fa fa-user fa-fw\"></i> User Profile</a>\n\t\t\t\t</li>\n\t\t\t\t<li><a href=\"#\"><i class=\"fa fa-gear fa-fw\"></i> Settings</a>\n\t\t\t\t</li>\n\t\t\t\t<li class=\"divider\"></li>\n\t\t\t\t<li><a href=\"login.html\"><i class=\"fa fa-sign-out fa-fw\"></i> Logout</a>\n\t\t\t\t</li>\n\t\t\t</ul>\n\t\t\t<!-- /.dropdown-user -->\n\t\t</li>\n\t\t<!-- /.dropdown -->\n\t</ul>\n\t\n\t<sn-side-nav></sn-side-nav>\n\t\n</nav>"

/***/ }
/******/ ])));


/** WEBPACK FOOTER **
 ** app.js
 **/